import { Component, EventEmitter, OnInit, Output } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { Helper } from 'app/common/helper';
import { APIEnum, Constant, ErrorEnum, FIELD_COMPONENT, FolderNameDropPDFEnum, MODULE_NAME, TypeMediaFileEnum } from 'app/config/constants';
import { DialogConfirmComponent } from 'app/dialog/dialog-confirm/dialog-confirm.component';
import { DialogEmergencyModeComponent } from 'app/dialog/dialog-emergency-mode/dialog-emergency-mode.component';
import { DialogMessageComponent } from 'app/dialog/dialog-message/dialog-message.component';
import { DialogOperationInformationSettingScheduleComponent } from 'app/dialog/dialog-operation-information-setting-schedule/dialog-operation-information-setting-schedule.component';
import { DialogShowHiddenItemSettingSettingComponent } from 'app/dialog/dialog-show-hidden-item-setting/dialog-show-hidden-item-setting.component';
import { Common } from 'app/model/entity/common';
import { DynamicMessage } from 'app/model/entity/dynamic-message';
import { EmergencyData } from 'app/model/entity/emergency-data';
import { Image as ImageDynamicMessage } from 'app/model/entity/image';
import { Media } from 'app/model/entity/media';
import { DynamicMessageSchedule } from 'app/model/entity/schedule/dynamic-message-schedule';
import { TimetableDaily } from 'app/model/entity/schedule/timetables-daily';
import { APICustomerService } from 'app/service/api-customer.service';
import { CommonService } from 'app/service/common.service';
import { DataService } from 'app/service/data.service';
import { DeviceService } from 'app/service/device.service';
import { DialogService } from 'app/service/dialog.service';
import { DynamicMessageService } from 'app/service/dynamic-message.service';
import { EmergencyDataService } from 'app/service/emergency-data.service';
import { ExecutingService } from 'app/service/executing.service';
import { MediaService } from 'app/service/media.service';
import { MenuActionService } from 'app/service/menu-action.service';
import { ScheduleMergeService } from 'app/service/schedule-merge.service';
import { ScheduleOperationManagerService } from 'app/service/schedule-operation-maganer.service';
import _ from 'lodash';
import moment from 'moment';
import { ToastrService } from 'ngx-toastr';
import { forkJoin, of, Subject, Subscription } from 'rxjs';
import { v4 as uniqueId } from 'uuid';
import { MediaFileDropped } from '../lcd-layout-editor/lcd-layout-editor.component';

import { DialogMessageOperationComponent } from 'app/dialog/dialog-message-operation/dialog-message-operation.component';
import { DialogEmergencyOperationComponent } from 'app/dialog/dialog-emergency-operation/dialog-emergency-operation.component';
import { Device } from 'app/model/entity/device';
import { TextHighlightSettingService } from 'app/service/text-highlight-setting-service';
import { TextHighlightingSetting } from 'app/model/entity/text-highlighting-setting';
import { CommonTableService } from 'app/service/common-table.service';
import { takeUntil } from 'rxjs/operators';
@Component({
  selector: 'schedule-operation-manager',
  templateUrl: './schedule-operation-manager.component.html',
  styleUrls: ['./schedule-operation-manager.component.scss']
})
export class ScheduleOperationManagerComponent implements OnInit {
  /**
   * PATH_ANGLE_DOUBLE_RIGHT
   */
  public PATH_ANGLE_DOUBLE_RIGHT = Constant.PATH_ANGLE_DOUBLE_RIGHT;
  /**
   * Helper
   */
  public Helper = Helper;
  /**
   * true if enlarge preview
   */
  public isEnlargePreview: boolean = true;
  /**
   * schedule selected
   */
  public scheduleSelected: any;

  /**
   * schedule selected clone
   */
  public scheduleSelectedClone: any;

  /**
   * list display
   */
  public nameDisplayClone: string;
  suspension = '運休';
  /**
   * schedule edit
   */
  public scheduleEdit: any;

  /**
   * schedule edit array
   */
  public scheduleEditArray: any[] = [];

  /**
   * schedule insert array
   */
  public scheduleInsertArray: any[] = [];
  /**
   * number row insert
   */
  public numRowInsert: number = -1;

  /**
   * schedule delete array
   */
  public scheduleDeleteArray: any[] = [];
  /**
   * tenant name
   */
  private tenantName: any;
  /**
   * schedules daily
   */
  public schedulesDaily: any[] = [];
  /**
   * timetables daily
   */
  public timetablesDaily: TimetableDaily[] = new Array<TimetableDaily>();
  /**
   * label schedule
   */
  public labelSchedule: string;
  /**
   * subscriptions
   */
  private subscriptions: Array<Subscription> = new Array<Subscription>();
  /**
   * devices
   */
  public devices: DeviceOperation[];

  public deviceIdSelected: any;
  /**
   * true if edit row
   */
  public isEditRow: boolean;
  /**
   * device selected
   */
  public deviceSelected: DeviceOperation;

  dataLengthAPI;
  /**
   * size of data load from api
   */
  private size = 50;
  /**
   * index last of data schedulesDaily
   */
  private indexItem = 0;
  /**
   * isLoadHeader of data schedulesDaily
   */
  private isLoadHeader = false;
  /**
   * stopLazyScroll
   */
  public stopLazyScroll: Subject<any> = new Subject<any>();

  public ngUnsubscribe: Subject<void> = new Subject<void>();

  public isActiveTabCapture: boolean = true;
  // public deviceSelected: DeviceOperation;

  public loadMoreScrollDown(): void {
    if (this.dataLengthAPI < this.size) {
      return;
    }
    this.getData(this.indexItem, this.size, true);
  }

  public loadMoreScrollUp(): void {
    if (this.dataLengthAPI < this.size) {
      return;
    }
    this.getData(this.indexItem, this.size, false);
  }

  public scrollToElementById(id: string) {
    if (id == '-1') {
      var myDiv = document.getElementById('tableDiv');
      if (myDiv) {
        myDiv.scrollTop = 0;
      }
      return;
    }
    const element = document.getElementById(id);
    if (!element) {
      setTimeout(() => {
        this.scrollToElementById(id);
      }, 100);
    }
    if (element) {
      element.scrollIntoView();
    }
  }
  isViewJp: boolean = true;
  /**
   * listDataColor
   */
  listDataColor: TextHighlightingSetting[] = [
    {
      id: 1,
      titleName: 'highlight-delay',
      name: 'Delay',
      blinking: false,
      object: 'row',
      color: '#c30c22',
      isActive: false,
      readOnlyName: true,
      opacity: 1
    },
    {
      id: 2,
      titleName: 'highlight-priority',
      name: 'Priority',
      blinking: true,
      object: 'time',
      color: '#8cc318',
      isActive: false,
      readOnlyName: true,
      opacity: 1
    },
    {
      id: 3,
      titleName: 'highlight-1',
      name: '空港線用',
      blinking: true,
      object: 'row',
      color: '#00a0e9',
      isActive: false,
      readOnlyName: false,
      opacity: 1
    },
    {
      id: 4,
      titleName: 'highlight-2',
      name: '臨時便用',
      blinking: true,
      object: 'row',
      color: '#faee00',
      isActive: false,
      readOnlyName: false,
      opacity: 1
    },
    {
      id: 5,
      titleName: 'highlight-3',
      name: '運休用',
      blinking: false,
      object: 'row',
      color: '#ea5514',
      isActive: false,
      readOnlyName: false,
      opacity: 1
    }
  ];

  /**
   * headers
   */
  public headers: any[];
  /**
   * header APIs
   */
  public headerCRUDs: any[];
  // public headerTabEdits: any[];

  public headerAPIs: any[];

  /**
   * true if network OK
   */
  public isNetworkOK: boolean;

  /**
   * apiUpdateData
   */
  private apiUpdateData: string;

  /**
   * timeDateLine
   */
  timeDateLine: string;

  /**
   * common object
   */
  private commonObject: Common;
  /**
   * save data success
   */
  @Output() saveDataSuccess = new EventEmitter<boolean>();
  dynamicMessages: Array<DynamicMessageSchedule>;
  oldDynamicMessages: Array<DynamicMessageSchedule>;
  isEditDynamicMessageMode: boolean;
  isEditEmergencyMode: boolean;
  isOnlyTextArea: boolean;
  isOnlyPictureArea: boolean;
  mediaFilesDroppedOperation: any;
  filesData: any;
  mediaIdsToDelete: any;
  private readonly updateStateItemOnMenu = new Subject();
  private readonly propertiesName = {
    dynamicMessage: this.translateService.instant('dialog-message.timetable-operation.dynamic-message'),
    emergencyLinkText: this.translateService.instant('dialog-message.timetable-operation.link-text')
  };
  emergencyData: EmergencyData;
  emergencyMediaIdOld: number;

  regexTime: any;
  formatTime: string;
  haveTimess: boolean = true;
  timeAdd: number = 0;
  item7s: any[] = [];

  constructor(
    private scheduleMergeService: ScheduleMergeService,
    private scheduleOperationManagerService: ScheduleOperationManagerService,
    private translateService: TranslateService,
    private actionService: MenuActionService,
    private dialogService: DialogService,
    private executingService: ExecutingService,
    private deviceService: DeviceService,
    private apiCustomerService: APICustomerService,
    private commonService: CommonService,
    private dataService: DataService,
    private dynamicMessageService: DynamicMessageService,
    private emergencyDataService: EmergencyDataService,
    private mediaService: MediaService,
    private toast: ToastrService,
    private textHighlightSettingService: TextHighlightSettingService,
    private commonTableService: CommonTableService
  ) {
    this.subscriptions.push(
      this.actionService.actionShowHiddenItemSetting.subscribe(moduleName => {
        if (moduleName == MODULE_NAME[FIELD_COMPONENT.ScheduleOperationManagerComponent]) {
          this.showHiddenItemSetting();
        }
      })
    );
    // insert row
    this.subscriptions.push(
      this.actionService.actionInsertRow.subscribe(module => {
        if (module == MODULE_NAME[FIELD_COMPONENT.ScheduleOperationManagerComponent]) {
          this.insertRow();
        }
      })
    );
    // edit row
    this.subscriptions.push(
      this.actionService.actionEditRow.subscribe(module => {
        if (module == MODULE_NAME[FIELD_COMPONENT.ScheduleOperationManagerComponent]) {
          this.editRow();
        }
      })
    );
    // delete row
    this.subscriptions.push(
      this.actionService.actionDeleteRow.subscribe(module => {
        if (module == MODULE_NAME[FIELD_COMPONENT.ScheduleOperationManagerComponent]) {
          this.deleteRow();
        }
      })
    );
    // duplicate row
    this.subscriptions.push(
      this.actionService.actionDuplicateRow.subscribe(module => {
        if (module == MODULE_NAME[FIELD_COMPONENT.ScheduleOperationManagerComponent]) {
          this.duplicateRow();
        }
      })
    );
    // updatedate
    this.subscriptions.push(
      this.actionService.actionUpdateData.subscribe(module => {
        if (module == MODULE_NAME[FIELD_COMPONENT.ScheduleOperationManagerComponent]) {
          this.checkBeforeUpdate();
        }
      })
    );
    this.subscriptions.push(
      this.actionService.actionDynamicMessage.subscribe(module => {
        if (module == MODULE_NAME[FIELD_COMPONENT.ScheduleOperationManagerComponent]) {
          this.openDynamicMessage();
        }
      })
    );
    this.subscriptions.push(
      this.actionService.actionEmergency.subscribe(module => {
        if (module == MODULE_NAME[FIELD_COMPONENT.ScheduleOperationManagerComponent]) {
          this.openEmergency();
        }
      })
    );
    this.subscriptions.push(
      this.translateService.onLangChange.subscribe(() => {
        this.checkViewJP();
      })
    );
    this.commonObject = commonService.getCommonObject();
    this.subscriptions.push(
      this.updateStateItemOnMenu.subscribe(() => {
        this.dataService.sendData([
          `${MODULE_NAME[FIELD_COMPONENT.ScheduleOperationManagerComponent]}:isEditDynamicMessageMode`,
          this.isEditDynamicMessageMode
        ]);
        this.dataService.sendData([
          `${MODULE_NAME[FIELD_COMPONENT.ScheduleOperationManagerComponent]}:isEditEmergencyMode`,
          this.isEditEmergencyMode
        ]);
      })
    );
  }

  ngOnInit(): void {
    this.checkViewJP();
    this.getInformationScheduleOperation();
    this.getAllDevices();
    this.getAllTextColor();
    this.getApiUpdateData();
  }
  checkViewJP() {
    const tmpView = this.translateService.instant('schedule-operation-manager.suspension');
    this.isViewJp = tmpView && tmpView.length > 4 ? false : true;
  }
  ngOnDestroy() {
    this.subscriptions.forEach(subscription => subscription.unsubscribe());
  }

  getData(index, size, isScrollDown, loadLast?, scrollTo?) {
    if (index < 0) {
      return;
    } else if (!isScrollDown && index <= size * 3) {
      return;
    }
    if (this.isEditRow) {
      return;
    }
    this.indexItem = index;
    let dataArr;
    this.scheduleOperationManagerService.getScheduleOperationFromAPI(index, size, isScrollDown).subscribe(data => {
      if (data && data.length > 0) {
        if (isScrollDown) {
          if (loadLast) {
            dataArr = data;
            this.indexItem = index + size;
          } else {
            //if scroll down => push data
            dataArr = [...this.schedulesDaily, ...data];
            this.indexItem += size;
          }
        } else {
          //if scroll up => unshift data
          dataArr = [...data, ...this.schedulesDaily];
          this.indexItem -= size;
          this.scrollToElementById('0'); //scroll to id (O) before add data.
          setTimeout(() => {
            this.scrollToElementById((this.dataLengthAPI < index ? this.dataLengthAPI + size - index : size) + '');
          }, 300);
        }
        this.schedulesDaily = this.scheduleOperationManagerService.arrConvertData(index, size, isScrollDown, dataArr);
        if (scrollTo) {
          setTimeout(() => {
            this.scrollToElementById(parseInt(scrollTo) > this.schedulesDaily.length ? this.schedulesDaily.length - 1 : scrollTo);
          }, 500);
          // this.scrollToElementById(scrollTo);
        }

        if (!this.isLoadHeader && this.schedulesDaily) {
          this.addRowToHeader();
        }
        const indexSelected = this.schedulesDaily.findIndex(e => e.key == this.scheduleSelected?.key);
        if (indexSelected == -1) {
          this.scheduleSelected = null; // reset selected if load more row out size of last seleted
          this.sendDataEnableEdit();
        }
      }
    });
  }

  /**
   * add row to header
   */
  public addRowToHeader(): void {
    this.scheduleOperationManagerService.getShowHiddenItem().subscribe(
      e => {
        if (e && e.length > 0) {
          this.headerAPIs = e;
          this.checkDataS3WithDB(); //fix tam
        } else {
          this.checkDataS3WithDB();
        }
      },
      err => {
        this.checkDataS3WithDB();
      }
    );
  }
  addHeader() {
    const headers = [];
    const headerCRUDs = [];
    const headerLabelsFromAPI = this.scheduleOperationManagerService.listScheduleOperationFromAPI.headers
      ? JSON.parse(this.scheduleOperationManagerService.listScheduleOperationFromAPI.headers)
      : null;
    const listReject = [
      'calculatedTime',
      'suspension',
      'hold',
      'priority',
      'color',
      'index',
      'checkTime',
      'notIn35Min',
      'blink',
      'isDelete',
      'isDeleteRowInsert',
      'isEdit',
      'isEditHold',
      'isEditPriority',
      'isEditSuspension',
      'key',
      'itemEdit'
    ];
    const listRejectCRUD = [
      'calculatedTime',
      'suspension',
      'hold',
      'priority',
      'color',
      'index',
      'checkTime',
      'notIn35Min',
      'blink',
      'isEdit',
      'isDelete',
      'isDeleteRowInsert',
      'isEditHold',
      'isEditPriority',
      'isEditSuspension',
      'key',
      'itemEdit'
    ];
    for (const headerAPI of this.headerAPIs) {
      if (headerAPI.isActive) {
        headers.push(headerAPI);
      } else {
        listReject.push(headerAPI.field);
      }
    }
    headers.sort((a, b) => (a.sortOrder > b.sortOrder ? 1 : -1));

    const headerRows = JSON.parse(JSON.stringify(this.scheduleOperationManagerService.listScheduleOperationFromAPI.entry[0]));
    for (const header in headerRows) {
      let label = header;
      if (headerLabelsFromAPI) {
        label = headerLabelsFromAPI[headers.length];
      }
      const re = listReject.findIndex(e => e == header);
      if (re == -1) {
        const i = headers.findIndex(e => e.field == header);
        if (i == -1) {
          headers.push({ label: label, field: header });
        }
      }
      const reCrud = listRejectCRUD.findIndex(e => e == header);
      if (reCrud == -1) {
        if (headerLabelsFromAPI) {
          label = headerLabelsFromAPI[headerCRUDs.length];
        }
        headerCRUDs.push({ label: label, field: header });
      }
    }
    this.headers = headers;
    this.headerCRUDs = headerCRUDs;

    this.isLoadHeader = true;
  }
  checkDataS3WithDB() {
    if (
      !this.scheduleOperationManagerService.listScheduleOperationFromAPI.entry ||
      !this.scheduleOperationManagerService.listScheduleOperationFromAPI.entry[0]
    ) {
      return;
    }
    const headers = [];
    const headerRows = JSON.parse(JSON.stringify(this.scheduleOperationManagerService.listScheduleOperationFromAPI.entry[0]));
    const listReject = [
      'calculatedTime',
      'hold',
      'priority',
      'suspension',
      'color',
      'index',
      'key',
      'itemEdit',
      'checkTime',
      'notIn35Min',
      'blink'
    ];
    let index = 0;

    const headerLabelsFromAPI = this.scheduleOperationManagerService.listScheduleOperationFromAPI.headers
      ? JSON.parse(this.scheduleOperationManagerService.listScheduleOperationFromAPI.headers)
      : null;
    for (const header in headerRows) {
      let label = header;
      const re = listReject.findIndex(e => e == header);
      if (re == -1) {
        const i = headers.findIndex(e => e.field == header);
        if (i == -1) {
          if (headerLabelsFromAPI) {
            label = headerLabelsFromAPI[headers.length];
          }
          headers.push({ label: label, field: header, isActive: true, sortOrder: index++ });
          if (this.headerAPIs) {
            for (const dataTmpApi of this.headerAPIs) {
              if (dataTmpApi.field == header) {
                headers[headers.length - 1].checkApi = true;
                if (dataTmpApi.label != label) {
                  headers[headers.length - 1].checkApi = false;
                }
                headers[headers.length - 1].sortOrder = dataTmpApi.sortOrder;
                headers[headers.length - 1].isActive = dataTmpApi.isActive;
              }
            }
          }
        }
      }
    }
    let checkApi = true;
    for (const header of headers) {
      if (!header.checkApi) {
        //convert sort order. call api save item;
        checkApi = false;
      }
    }
    if (checkApi) {
      this.addHeader();
      return;
    }
    this.headers = headers;
    this.headerCRUDs = headers;
    this.isLoadHeader = true;
  }
  resetHeader() {
    const headers = [];
    const listReject = [
      'calculatedTime',
      'hold',
      'priority',
      'suspension',
      'color',
      'index',
      'key',
      'itemEdit',
      'checkTime',
      'notIn35Min',
      'blink',
      'isDelete',
      'isDeleteRowInsert',
      'isEdit',
      'isEditHold',
      'isEditPriority',
      'isEditSuspension'
    ];
    const headerRows = JSON.parse(JSON.stringify(this.schedulesDaily[0]));
    for (const header in headerRows) {
      const re = listReject.findIndex(e => e == header);
      if (re == -1) {
        headers.push({ label: header, field: header });
      }
    }
    this.headers = headers;
    this.headerCRUDs = headers;
    this.isLoadHeader = true;
  }
  /**
   * enlarge preview
   */
  public enlargePreview(): void {
    this.isEnlargePreview = !this.isEnlargePreview;
  }

  /**
   * select schedule
   * @param index
   * @returns
   */
  public selectSchedule(index: number): void {
    if (this.isEditRow) {
      return;
    }
    if (this.checkRealTime(this.schedulesDaily[index])) {
      this.scheduleSelected = this.schedulesDaily[index];
      this.sendDataEnableEdit();
    }
  }

  /**
   * change prevent
   * @param index
   * @returns
   */
  public changePrevent(index: number): void {
    if (!this.checkEnableEdit(index)) {
      return;
    }
    if (this.schedulesDaily[index].delete || this.schedulesDaily[index].isDelete) {
      //check if delete -> return;
      return;
    }
    this.schedulesDaily[index].hold = !this.schedulesDaily[index].hold;
  }
  public changeSuspension(index: number): void {
    if (!this.checkEnableEdit(index)) {
      return;
    }
    if (this.schedulesDaily[index].delete || this.schedulesDaily[index].isDelete) {
      //check if delete -> return;
      return;
    }
    if (this.checkRealTime(this.schedulesDaily[index])) {
      this.schedulesDaily[index].suspension = !this.schedulesDaily[index].suspension;
    }
  }
  checkEnableEdit(index: number): boolean {
    if (this.isEditRow) {
      return false;
    }
    if (
      this.schedulesDaily[index].item6 &&
      (this.schedulesDaily[index].item6 == this.suspension || this.schedulesDaily[index].item6.toLowerCase() == 'suspension')
    ) {
      return false;
    }
    return true;
  }
  /**
   * change priority
   * @param index
   * @returns
   */
  public changePriority(index: number): void {
    if (!this.checkEnableEdit(index)) {
      return;
    }
    if (this.schedulesDaily[index].delete || this.schedulesDaily[index].isDelete) {
      //check if delete -> return;
      return;
    }
    if (this.checkRealTime(this.schedulesDaily[index])) {
      this.schedulesDaily[index].priority = !this.schedulesDaily[index].priority;
    }
  }

  checkRealTime(item): boolean {
    if (item && !item.time) {
      return true;
    }
    // true is time(item) > real time.
    if (item.checkTime) {
      // if checked = false -> return.
      return false;
    } else if (item.notIn35Min) {
      return true;
    }
    const dateNow = new Date();
    const time = moment(dateNow)
      .format(this.formatTime)
      .replace(/:?/g, '');
    const timeInt = parseInt(time) + (this.formatTime == 'HH:mm:ss' ? this.timeAdd * 10000 : this.timeAdd * 100);
    const timeRow = parseInt(item.time.replace(/:?/g, ''));
    if (timeRow > timeInt) {
      if ((this.formatTime == 'HH:mm:ss' && timeRow - timeInt > 6000) || (this.formatTime == 'HH:mm' && timeRow - timeInt > 60)) {
        item.notIn35Min = true;
      }
      return true;
    } else {
      if (this.scheduleSelected && this.scheduleSelected.key == item.key) {
        if (this.scheduleSelected.key == item.key && this.isEditRow) {
          return true;
        }
        this.scheduleSelected = null;
        this.sendDataEnableEdit();
      }
      item.checkTime = true;
      return false;
    }
  }

  /**
   * get data current day
   * @returns
   */
  private getDataCurrentDay(): TimetableDaily[] {
    let date = Helper.getCurrentByTimezoneSetting(this.commonObject, false);
    let year = date.getFullYear();
    let month = date.getMonth() + 1;
    let day = date.getDate();
    const hoursAndMinutes = date.getHours() * 3600 + date.getMinutes() * 60;
    const timeDateLineSecond = parseInt(this.timeDateLine.split(':')[0]) * 3600 + parseInt(this.timeDateLine.split(':')[1]) * 60;
    if (timeDateLineSecond > hoursAndMinutes) {
      day = day - 1;
    }
    let timeZone = this.commonService
      .getCommonObject()
      .setting.timezone.name.split(' ')[0]
      .replace(')', '')
      .replace('(', '');
    this.labelSchedule = Helper.formatString(
      this.translateService.instant('schedule-operation-manager.label-schedule'),
      `${year}`,
      `${month}`,
      `${day}`
    );
    this.scheduleMergeService
      .getDataCurrentDay(year.toString(), month.toString().padStart(2, '0'), day.toString().padStart(2, '0'), timeZone)
      .subscribe(data => {
        this.scheduleOperationManagerService.listScheduleOperationFromAPI = data;
        if (data && data.item7s) this.item7s = JSON.parse(data.item7s);
        if (data && data.timeAdd) {
          this.timeAdd = data.timeAdd;
        }
        this.scheduleOperationManagerService.convertDataOperationApi();
        this.addRowToHeader();
        if (data && data.entry && data.entry[0]) {
          this.dataLengthAPI = this.scheduleOperationManagerService.listScheduleOperationFromAPI.entry.length;
          this.checkTypeDate(data.entry[0]);
          this.findFirstKey();
        }
      });
    return this.timetablesDaily;
  }

  /**
   * reload data
   */
  public reloadData(isUpdateData = false) {
    let date = Helper.getCurrentByTimezoneSetting(this.commonObject, false);
    let year = date.getFullYear();
    let month = date.getMonth() + 1;
    let day = date.getDate();
    // reset all options to default;
    this.schedulesDaily = [];
    this.scheduleEditArray = [];
    this.scheduleInsertArray = [];
    this.scheduleDeleteArray = [];
    this.indexItem = 0;
    //if have find to Schedule -> no set value selected to null -> target schedule selected
    this.scheduleSelected = null;
    this.sendDataEnableEdit();
    let timeZone = this.commonService
      .getCommonObject()
      .setting.timezone.name.split(' ')[0]
      .replace(')', '')
      .replace('(', '');
    const hoursAndMinutes = date.getHours() * 3600 + date.getMinutes() * 60;
    const timeDateLineSecond = parseInt(this.timeDateLine.split(':')[0]) * 3600 + parseInt(this.timeDateLine.split(':')[1]) * 60;
    if (timeDateLineSecond > hoursAndMinutes) {
      day = day - 1;
    }
    this.scheduleMergeService
      .getDataCurrentDay(year.toString(), month.toString().padStart(2, '0'), day.toString().padStart(2, '0'), timeZone)
      .subscribe(data => {
        this.scheduleOperationManagerService.listScheduleOperationFromAPI = data;
        this.scheduleOperationManagerService.convertDataOperationApi();
        if (isUpdateData) {
          //click update data. show dialog if reload done
          this.dialogService.showDialog(DialogMessageComponent, {
            data: {
              title: this.translateService.instant('dialog-confirm.title'),
              text: this.translateService.instant('schedule-operation-manager.update-success')
            }
          });
        }
        this.findFirstKey();
      });
  }
  findFirstKey() {
    for (const [index, schedule] of this.scheduleOperationManagerService.listScheduleOperationFromAPI.entry.entries()) {
      if (this.checkRealTime(schedule)) {
        this.scheduleSelected = schedule;
        this.sendDataEnableEdit();
        this.loadDataWithKeyNum(index + 1);
        return;
      }
      if (schedule.hold || this.checkRealTime(schedule)) {
        this.loadDataWithKeyNum(index + 1);
        return;
      }
    }
    this.loadDataWithKeyNum(this.scheduleOperationManagerService.listScheduleOperationFromAPI.entry.length);
    return;
  }
  loadDataWithKeyNum(key) {
    this.indexItem = 0;
    const numSize = (key - (key % this.size)) / this.size;
    let numIndexItem;
    let scrollTo;
    this.schedulesDaily = [];
    if (numSize < 2) {
      numIndexItem = 0;
      scrollTo = key - 5;
    } else if ((numSize + 1) * this.size <= this.dataLengthAPI) {
      numIndexItem = this.size * (numSize - 1);
      scrollTo = (key % this.size) - 5 + this.size; //(key % this.size == 0 ? 0 : this.size);
    } else {
      numIndexItem = this.size * (numSize - 2);
      scrollTo = (key % this.size) - 5 + this.size * 2;
    }
    this.getData(numIndexItem, this.size * 3, true, false, (scrollTo < 0 ? -1 : scrollTo) + '');
  }
  checkTypeDate(schedule) {
    //check type time is hh:mm or hh:mm:ss
    if (schedule.time.length < 6) {
      this.haveTimess = false;
      this.formatTime = 'HH:mm';
      this.regexTime = Helper.formatTimeRegex(Constant.FORMAT_TIME_MINUTE1_REGEX_0, this.timeDateLine);
    } else {
      this.haveTimess = true;
      this.formatTime = 'HH:mm:ss';
      this.regexTime = Helper.formatTimeRegex(Constant.FORMAT_TIME_SECOND_REGEX_0, this.timeDateLine);
    }
  }
  /**
   * operation information setting
   */
  private showHiddenItemSetting(): void {
    // open popup
    this.dialogService.showDialog(DialogShowHiddenItemSettingSettingComponent, { data: this.schedulesDaily }, result => {
      if (result) {
        this.addRowToHeader();
      }
    });
  }

  /**
   * change device
   * @param deviceId
   * @returns
   */
  public changeDevice(deviceId: any): void {
    this.deviceIdSelected = deviceId;
    this.deviceSelected = deviceId != -1 ? this.devices.find(item => item.id == deviceId) : undefined;
    if (!this.deviceSelected) {
      this.dataService.sendData([Constant.IS_NETWORK_OK, false]);
      this.isNetworkOK = false;
      return;
    }
    //set captureUrl to null
    this.deviceSelected.captureUrl = null;
    // call API status to check network controller device
    this.apiCustomerService.getCurrentStatusRequest([this.deviceSelected.registrationId]).subscribe(data => {
      this.isNetworkOK = !!_.get(data?.['completed'], `[0]`, undefined);
      // update information for device selected
      let deviceCompleted = data[Constant.COMPLETE_STATUS]?.find(item => this.deviceSelected.registrationId === item.id);
      this.dataService.sendData([Constant.IS_NETWORK_OK, !!deviceCompleted]);
    });
  }

  /**
   * get all devices
   */
  private getAllDevices(): void {
    this.deviceService.getDevice().subscribe(
      data => {
        this.devices = Helper.convertDataToDeviceOperation(data);
      },
      error => Helper.handleError(error, this.translateService, this.dialogService)
    );
  }

  /**
   * Capture screen device
   */
  public captureScreenDevice(): void {
    if (!this.deviceSelected) {
      this.handleShowMessage(Constant.ERROR_TITLE, 'no-device');
    }
    // call API status to check network controller device
    this.apiCustomerService.getCurrentStatusRequest([this.deviceSelected.registrationId]).subscribe(data => {
      this.isNetworkOK = !!_.get(data?.['completed'], `[0]`, undefined);
      // update information for device selected
      let deviceCompleted = data[Constant.COMPLETE_STATUS]?.find(item => this.deviceSelected.registrationId === item.id);
      this.dataService.sendData([Constant.IS_NETWORK_OK, !!deviceCompleted]);
      // check network OK/NG
      if (!deviceCompleted) {
        return;
      }
      // network OK => call API screen capture
      this.handleCallAPIScreenCapture();
    });
  }

  /**
   * handle call api screen capture
   */
  private handleCallAPIScreenCapture() {
    const payload = {
      device: this.deviceSelected.registrationId
    };
    this.apiCustomerService.captureScreenDevice(payload).subscribe(
      () => {
        this.executingService.executing();
        setTimeout(() => {
          this.deviceService.getDeviceScreenCaptureUrl(this.deviceSelected.registrationId).subscribe(
            data => {
              this.executingService.executed();
              if (!data) {
                return;
              }
              this.deviceSelected.captureUrl = data['url'];
            },
            () => {
              this.executingService.executed();
              this.handleShowMessage(Constant.ERROR_TITLE, Constant.COMMON_ERROR);
            }
          );
        }, 3000);
      },
      () => this.handleShowMessage(Constant.ERROR_TITLE, 'call-screen-failed')
    );
  }

  /**
   * Handle show message
   *
   * @param title
   * @param messageCode
   */
  private handleShowMessage(title: string, messageCode: string): void {
    this.dialogService.showDialog(DialogMessageComponent, {
      data: {
        title: this.translateService.instant(`schedule-operation-manager.message.${title}`),
        text: this.translateService.instant(`schedule-operation-manager.message.${messageCode}`)
      }
    });
  }
  pushDataToListView(objAdd, indexTable) {
    this.schedulesDaily.splice(indexTable, 0, objAdd);
    this.scheduleSelected = this.schedulesDaily[indexTable];
    this.sendDataEnableEdit();
  }
  pushDataAddToList(objAdd) {
    this.scheduleOperationManagerService.listScheduleOperationFromAPI.entry.push(objAdd);
    this.sortWithTimeEdit(objAdd.index);
  }
  sortWithTimeEdit(indexData) {
    this.scheduleOperationManagerService.listScheduleOperationFromAPI.entry.sort((a, b) =>
      parseInt(a.time.replace(/:?/g, '')) >= parseInt(b.time.replace(/:?/g, '')) ? 1 : -1
    );

    this.scheduleOperationManagerService.listScheduleOperationFromAPI.entry.forEach((e, index) => {
      e.key = index + 1;
      if (e.isEdit && e.index > 0) {
        let scheduleI = this.scheduleEditArray.findIndex(tmp => tmp.index == e.index);
        if (scheduleI != -1) {
          this.scheduleEditArray[scheduleI].key = index + 1;
        }
      }
      if (e.index < 0) {
        let scheduleI = this.scheduleInsertArray.findIndex(tmp => tmp.index == e.index);
        if (scheduleI != -1) {
          this.scheduleInsertArray[scheduleI].key = index + 1;
        }
      }
      if (e.isDelete) {
        let scheduleI = this.scheduleDeleteArray.findIndex(tmp => tmp.index == e.index);
        if (scheduleI != -1) {
          this.scheduleDeleteArray[scheduleI].key = index + 1;
        }
      }
    });
    const keySelected = this.scheduleOperationManagerService.listScheduleOperationFromAPI.entry.findIndex(e => e.index == indexData);
    this.loadDataWithKeyNum(keySelected);
  }
  /**
   * save edit item
   */
  public saveEditItem(): void {
    delete this.scheduleSelectedClone.notIn35Min; //clear check with edit or insert
    delete this.scheduleSelectedClone.checkTime; //clear check with edit or insert
    const time = this.scheduleSelectedClone.time;
    this.nameDisplayClone = undefined;
    let match = new RegExp(this.regexTime).exec(time);
    if (match == null) {
      this.handleShowMessage('error', 'time-invalid');
      return;
    }
    if (
      (this.scheduleSelectedClone.time.length < 8 && this.haveTimess) ||
      (this.scheduleSelectedClone.time.length < 5 && !this.haveTimess)
    ) {
      this.scheduleSelectedClone.time = '0' + this.scheduleSelectedClone.time;
    }
    let timeChange = _.clone(this.scheduleSelectedClone.time);

    // convert true format date
    // if((this.formatTime == 'HH:mm:ss' && time.length == 7) || (this.formatTime == 'HH:mm' && time.length == 4) ) {
    //   // this.scheduleSelectedClone.time = '0' + time;
    //   this.handleShowMessage('error', 'time-invalid');
    //   return;
    // }
    const dateNow = new Date();
    const now = moment(dateNow)
      .format(this.formatTime)
      .replace(/:?/g, '');
    const timeInt = parseInt(now) + (this.formatTime == 'HH:mm:ss' ? this.timeAdd * 10000 : this.timeAdd * 100);
    const numTimeDateLine =
      this.formatTime == 'HH:mm:ss' ? parseInt(this.timeDateLine.replace(/:?/g, '')) * 100 : this.timeDateLine.replace(/:?/g, '');
    let timeRow = parseInt(time.replace(/:?/g, ''));
    if (timeRow < numTimeDateLine) {
      timeRow = timeRow + (this.formatTime == 'HH:mm:ss' ? 24 * 10000 : 24 * 100);
      timeChange = (parseInt(this.scheduleSelectedClone.time.slice(0, 2)) + 24).toString() + this.scheduleSelectedClone.time.slice(2);
    }
    if (timeRow <= timeInt) {
      this.handleShowMessage('error', 'time-grey-out');
      return;
    }
    for (const header in this.scheduleSelectedClone) {
      if (this.scheduleSelectedClone[header].length > 256) {
        this.handleShowMessage('error', 'max-length');
        return;
      }
    }
    this.scheduleSelectedClone.time = timeChange;
    this.scheduleSelectedClone.calculatedTime = this.scheduleSelectedClone.time; //set calcilatedTime = time -> #1143
    const indexTable = this.schedulesDaily.findIndex(e => e?.key == this.scheduleSelected.key); //indexTable is order of table. index load from s3
    this.schedulesDaily[indexTable] = this.scheduleSelectedClone;
    this.scheduleSelected = this.scheduleSelectedClone;
    this.schedulesDaily[indexTable].isEdit = true;
    if (this.schedulesDaily[indexTable].index >= 0) {
      if (Object.keys(this.scheduleEdit).length <= 2) {
        this.isEditRow = false;
        this.dataService.sendData(['isEditRow', this.isEditRow]);
        this.schedulesDaily[indexTable].isEdit = false;
        return;
      }
      const indexDelete = this.scheduleDeleteArray.findIndex(e => e?.key == this.scheduleEdit.key); //find index edit in array

      const indexEdit = this.scheduleEditArray.findIndex(e => e?.key == this.scheduleEdit.key); //find index edit in array
      if (indexEdit == -1) {
        if (
          this.scheduleSelected.item6 &&
          (this.scheduleSelected.item6 == this.suspension || this.scheduleSelected.item6.toLowerCase() == 'suspension')
        ) {
          // onChangeCheckboxItem
          if (this.scheduleSelected.hold) {
            if (this.scheduleSelected.isEditHold) {
              this.scheduleSelected.hold = false;
              delete this.scheduleEdit.hold;
              this.scheduleSelected.isEditHold = false;
            } else {
              this.scheduleSelected.hold = false;
              this.scheduleEdit.hold = false;
              this.scheduleSelected.isEditHold = true;
            }
          }
          if (this.scheduleSelected.priority) {
            if (this.scheduleSelected.isEditPriority) {
              this.scheduleSelected.priority = false;
              delete this.scheduleEdit.priority;
              this.scheduleSelected.isEditPriority = false;
            } else {
              this.scheduleSelected.priority = false;
              this.scheduleEdit.priority = false;
              this.scheduleSelected.isEditPriority = true;
            }
          }
          if (this.scheduleSelected.suspension) {
            if (this.scheduleSelected.isEditSuspension) {
              this.scheduleSelected.suspension = false;
              delete this.scheduleEdit.suspension;
              this.scheduleSelected.isEditSuspension = false;
            } else {
              this.scheduleSelected.suspension = false;
              this.scheduleEdit.suspension = false;
              this.scheduleSelected.isEditSuspension = true;
            }
          }
        }
        this.scheduleEditArray.push(this.scheduleEdit);
      } else {
        this.scheduleEditArray[indexEdit] = { ...this.scheduleEditArray[indexEdit], ...this.scheduleEdit };
        if (
          this.scheduleSelected.item6 &&
          (this.scheduleSelected.item6 == this.suspension || this.scheduleSelected.item6.toLowerCase() == 'suspension')
        ) {
          // onChangeCheckboxItem
          if (this.scheduleSelected.hold) {
            if (this.scheduleSelected.isEditHold) {
              this.scheduleSelected.hold = false;
              delete this.scheduleEditArray[indexEdit].hold;
              this.scheduleSelected.isEditHold = false;
            } else {
              this.scheduleSelected.hold = false;
              this.scheduleEditArray[indexEdit].hold = false;
              this.scheduleSelected.isEditHold = true;
            }
          }
          if (this.scheduleSelected.priority) {
            if (this.scheduleSelected.isEditPriority) {
              this.scheduleSelected.priority = false;
              delete this.scheduleEditArray[indexEdit].priority;
              this.scheduleSelected.isEditPriority = false;
            } else {
              this.scheduleSelected.priority = false;
              this.scheduleEditArray[indexEdit].priority = false;
              this.scheduleSelected.isEditPriority = true;
            }
          }
          if (this.scheduleSelected.suspension) {
            if (this.scheduleSelected.isEditSuspension) {
              this.scheduleSelected.suspension = false;
              delete this.scheduleEditArray[indexEdit].suspension;
              this.scheduleSelected.isEditSuspension = false;
            } else {
              this.scheduleSelected.suspension = false;
              this.scheduleEditArray[indexEdit].suspension = false;
              this.scheduleSelected.isEditSuspension = true;
            }
          }
        }
      }
      if (indexDelete != -1) {
        this.scheduleDeleteArray[indexDelete] = { ...this.scheduleDeleteArray[indexDelete], ...this.scheduleEdit };
      }
      if (!this.scheduleSelected.itemEdit) {
        this.scheduleSelected.itemEdit = ',';
      }
      for (const key in this.scheduleEdit) {
        this.scheduleSelected.itemEdit += key + ',';
      }
      this.scheduleOperationManagerService.listScheduleOperationFromAPI.entry[this.scheduleSelected.key - 1] = this.scheduleSelected;
      this.isEditRow = false;
      this.dataService.sendData(['isEditRow', this.isEditRow]);
      if (this.scheduleEdit && this.scheduleEdit.time) {
        if (timeChange) {
          this.scheduleEdit.time = timeChange;
        }
        this.scheduleEdit.calculatedTime = this.scheduleEdit.time; //set calcilatedTime = time -> #1143
        this.sortWithTimeEdit(this.scheduleSelected.index);
      }
    } else {
      if (
        this.scheduleSelected.item6 &&
        (this.scheduleSelected.item6 == this.suspension || this.scheduleSelected.item6.toLowerCase() == 'suspension')
      ) {
        // onChangeCheckboxItem
        if (this.scheduleSelected.hold) {
          this.scheduleSelected.hold = false;
        }
        if (this.scheduleSelected.priority) {
          this.scheduleSelected.priority = false;
        }
        if (this.scheduleSelected.suspension) {
          this.scheduleSelected.suspension = false;
        }
      }
      this.scheduleSelected.isFirstEdit = false;
      const indexEdit = this.scheduleInsertArray.findIndex(e => e?.key == this.scheduleSelected.key); //find index edit in array
      if (indexEdit == -1) {
        this.scheduleInsertArray.push(this.scheduleSelected);
        this.isEditRow = false;
        this.dataService.sendData(['isEditRow', this.isEditRow]);
        this.pushDataAddToList(this.scheduleSelected);
        return;
      } else {
        this.scheduleInsertArray[indexEdit] = this.scheduleSelected;
        this.scheduleOperationManagerService.listScheduleOperationFromAPI.entry[this.scheduleSelected.key - 1] = this.scheduleSelected;
        this.isEditRow = false;
        this.dataService.sendData(['isEditRow', this.isEditRow]);
        this.sortWithTimeEdit(this.scheduleSelected.index);
      }
    }
  }

  /**
   * cancel edit item
   */
  public cancelEditItem(): void {
    this.isEditRow = false;
    this.nameDisplayClone = undefined;
    this.scheduleSelectedClone = null;
    let indexTable = this.schedulesDaily.findIndex(e => e?.key == this.scheduleSelected.key); //indexTable is order of table. index load from s3
    this.dataService.sendData(['isEditRow', this.isEditRow]);
    if (this.scheduleSelected.index < 0 && this.schedulesDaily[indexTable].isFirstEdit) {
      this.schedulesDaily.splice(indexTable, 1);
      this.scheduleSelected = null;
      this.numRowInsert++;
    } else {
      // this.scheduleSelected = this.scheduleSelectedClone;
      // this.schedulesDaily[indexTable] = this.scheduleSelectedClone;
    }
    this.sendDataEnableEdit();
  }

  /**
   * insert row
   */
  private insertRow(): void {
    let indexTable;
    if (this.isEditRow) {
      return;
    }
    if (!this.scheduleSelected) {
      this.dialogService.showDialog(DialogMessageComponent, {
        data: {
          title: this.translateService.instant('dialog-error.title'),
          text: this.translateService.instant('schedule-operation-manager.choose-row')
        }
      });
      return;
    } else {
      indexTable = this.schedulesDaily.findIndex(e => e?.key == this.scheduleSelected.key);
    }

    this.isActiveTabCapture = false;
    const objAdd: any = {};
    let itemEdit = ',';
    for (const header of this.headerCRUDs) {
      objAdd[header.field] = '';
      itemEdit += header.field + ',';
    }
    objAdd['key'] = this.numRowInsert;
    objAdd['index'] = this.numRowInsert--;
    objAdd['hold'] = false;
    objAdd['itemEdit'] = itemEdit;
    objAdd['priority'] = false;
    objAdd['suspension'] = '';
    objAdd['isFirstEdit'] = true;

    objAdd['isEditSuspension'] = true;
    objAdd['isEditHold'] = true;
    objAdd['isEditPriority'] = true;
    objAdd['isEdit'] = true;
    this.pushDataToListView(objAdd, indexTable);
    this.isEditRow = true;
    this.dataService.sendData(['isEditRow', this.isEditRow]);
  }
  /**
   * edit row
   */
  private editRow(): void {
    if (!this.scheduleSelected) {
      this.dialogService.showDialog(DialogMessageComponent, {
        data: {
          title: this.translateService.instant('dialog-error.title'),
          text: this.translateService.instant('schedule-operation-manager.choose-row')
        }
      });
      return;
    }
    this.isActiveTabCapture = false;
    this.scheduleEdit = { index: this.scheduleSelected.index, key: this.scheduleSelected.key };
    this.scheduleSelectedClone = _.cloneDeep(this.scheduleSelected);
    if (
      this.scheduleSelectedClone &&
      this.scheduleSelectedClone.time.length > 3 &&
      ((this.scheduleSelectedClone.time.length < 8 && this.haveTimess) || (this.scheduleSelectedClone.time.length < 5 && !this.haveTimess))
    ) {
      this.scheduleSelectedClone.time = '0' + this.scheduleSelectedClone.time;
    }
    this.isEditRow = true;
    this.dataService.sendData(['isEditRow', this.isEditRow]);
  }

  /**
   * on change checkbox item
   * @param type
   * @param i
   */
  onChangeCheckboxItem(type, i) {
    if (!this.checkRealTime(this.schedulesDaily[i]) && type != 'hold') {
      return;
    }
    if (!this.checkEnableEdit(i)) {
      return;
    }
    if (this.schedulesDaily[i].delete || this.schedulesDaily[i].isDelete) {
      //check if delete -> return;
      return;
    }
    this.scheduleSelected = this.schedulesDaily[i];
    this.scheduleSelectedClone = this.scheduleSelected;
    if (
      this.scheduleSelectedClone &&
      this.scheduleSelectedClone.time.length > 3 &&
      ((this.scheduleSelectedClone.time.length < 8 && this.haveTimess) || (this.scheduleSelectedClone.time.length < 5 && !this.haveTimess))
    ) {
      this.scheduleSelectedClone.time = '0' + this.scheduleSelectedClone.time;
    }
    this.sendDataEnableEdit();
    if (this.scheduleSelected.index >= 0) {
      const indexEdit = this.scheduleEditArray.findIndex(e => e?.key == this.scheduleSelected.key); //find index edit in array
      if (indexEdit == -1) {
        let scheduleEdit: any = { index: this.scheduleSelected.index, key: this.scheduleSelected.key };
        if (type === 'hold') {
          scheduleEdit.hold = this.scheduleSelected.hold;
          this.scheduleSelected.isEditHold = true;
        } else if (type == 'priority') {
          scheduleEdit.priority = this.scheduleSelected.priority;
          this.scheduleSelected.isEditPriority = true;
        } else if (type == 'suspension') {
          scheduleEdit.suspension = this.scheduleSelected.suspension;
          this.scheduleSelected.isEditSuspension = true;
        }
        this.scheduleEditArray.push(scheduleEdit);
      } else {
        //check change hold or priority before, if yes -> delete element
        if (type === 'hold') {
          if (this.scheduleEditArray[indexEdit].hold == undefined) {
            this.scheduleEditArray[indexEdit].hold = this.scheduleSelected.hold;
            this.scheduleSelected.isEditHold = true;
          } else {
            delete this.scheduleEditArray[indexEdit].hold;
            this.scheduleSelected.isEditHold = false;
          }
        } else if (type == 'priority') {
          if (this.scheduleEditArray[indexEdit].priority == undefined) {
            this.scheduleEditArray[indexEdit].priority = this.scheduleSelected.priority;
            this.scheduleSelected.isEditPriority = true;
          } else {
            delete this.scheduleEditArray[indexEdit].priority;
            this.scheduleSelected.isEditPriority = false;
          }
        } else if (type == 'suspension') {
          if (this.scheduleEditArray[indexEdit].suspension == undefined) {
            this.scheduleEditArray[indexEdit].suspension = this.scheduleSelected.suspension;
            this.scheduleSelected.isEditSuspension = true;
          } else {
            delete this.scheduleEditArray[indexEdit].suspension;
            this.scheduleSelected.isEditSuspension = false;
          }
        }
      }
      this.scheduleOperationManagerService.listScheduleOperationFromAPI.entry[this.scheduleSelected.key - 1] = this.scheduleSelected;
    } else {
      const indexEdit = this.scheduleInsertArray.findIndex(e => e?.key == this.scheduleSelected.key); //find index edit in array
      this.scheduleInsertArray[indexEdit] = this.scheduleSelected;
      this.scheduleOperationManagerService.listScheduleOperationFromAPI.entry[this.scheduleSelected.key - 1] = this.scheduleSelected;
    }
    if (!this.checkRealTime(this.scheduleSelected)) {
      //if time out and check hold -> set schedule selected = null;
      this.scheduleSelected = null;
      this.sendDataEnableEdit();
    }
  }
  /**
   * delete row
   */
  private deleteRow(): void {
    if (!this.scheduleSelected) {
      this.dialogService.showDialog(DialogMessageComponent, {
        data: {
          title: this.translateService.instant('dialog-error.title'),
          text: this.translateService.instant('schedule-operation-manager.choose-row')
        }
      });
      return;
    }
    if (this.isEditRow) {
      return;
    }
    if (this.scheduleSelected.isDelete) {
      // undeleteRow
      this.dialogService.showDialog(
        DialogConfirmComponent,
        {
          data: {
            text: this.translateService.instant(`schedule-operation-manager.confirm-undelete`),
            button1: this.translateService.instant('timetable-editor.yes'),
            button2: this.translateService.instant('timetable-editor.btn-no')
          }
        },
        result => {
          if (!result) {
            return;
          }
          this.handleUndeleteTimetables();
        }
      );
    } else {
      // deleteRow
      this.dialogService.showDialog(
        DialogConfirmComponent,
        {
          data: {
            text: this.translateService.instant(`schedule-operation-manager.confirm-delete`),
            button1: this.translateService.instant('timetable-editor.yes'),
            button2: this.translateService.instant('timetable-editor.btn-no')
          }
        },
        result => {
          if (!result) {
            return;
          }
          this.handleDeleteTimetables();
        }
      );
    }
  }
  handleDeleteTimetables() {
    this.scheduleDeleteArray.push(this.scheduleSelected);
    this.scheduleSelected.isDelete = true;
    if (this.scheduleSelected.index < 0) {
      this.scheduleSelected.isDeleteRowInsert = true;
    }
    this.scheduleOperationManagerService.listScheduleOperationFromAPI.entry[this.scheduleSelected.key - 1] = this.scheduleSelected;
    this.scheduleSelected = null;
    this.sendDataEnableEdit();
  }
  handleUndeleteTimetables() {
    if (this.scheduleSelected.isDelete) {
      const indexUndelete = this.scheduleDeleteArray.findIndex(e => e.index == this.scheduleSelected.index);
      if (indexUndelete != -1) {
        this.scheduleDeleteArray.splice(indexUndelete, 1);
      }
    }
    delete this.scheduleSelected.isDelete;
    this.scheduleOperationManagerService.listScheduleOperationFromAPI.entry[this.scheduleSelected.key - 1] = this.scheduleSelected;
    this.sendDataEnableEdit();
  }

  /**
   * duplicate row
   */
  private duplicateRow(): void {
    let indexTable;
    if (!this.scheduleSelected) {
      this.dialogService.showDialog(DialogMessageComponent, {
        data: {
          title: this.translateService.instant('dialog-error.title'),
          text: this.translateService.instant('schedule-operation-manager.choose-row')
        }
      });
      return;
    } else {
      indexTable = this.schedulesDaily.findIndex(e => e?.key == this.scheduleSelected.key);
    }
    if (this.isEditRow) {
      return;
    }
    this.isActiveTabCapture = false;

    // this.headerTabEdits = this.headerCRUDs;
    let itemEdit = ',';
    for (const header of this.headerCRUDs) {
      itemEdit += header.field + ',';
    }
    const objAdd: any = { ...this.scheduleSelected };
    objAdd['key'] = this.numRowInsert;
    objAdd['index'] = this.numRowInsert--;
    objAdd['itemEdit'] = itemEdit;
    objAdd['isFirstEdit'] = true;
    objAdd['isEdit'] = true;
    objAdd['isEditSuspension'] = true;
    objAdd['isEditHold'] = true;
    objAdd['isEditPriority'] = true;
    delete objAdd.isDelete;
    delete objAdd.delete;
    this.pushDataToListView(objAdd, indexTable + 1);
    // this.schedulesDaily.push(objAdd);
    // this.scheduleSelected = this.schedulesDaily[this.schedulesDaily.length - 1];
    this.isEditRow = true;
    this.dataService.sendData(['isEditRow', this.isEditRow]);
  }
  sendDataEnableEdit() {
    let dataSend: any = this.scheduleSelected ? true : false;
    this.scheduleSelectedClone = JSON.parse(JSON.stringify(this.scheduleSelected));
    if (
      this.scheduleSelectedClone &&
      this.scheduleSelectedClone.time.length > 3 &&
      ((this.scheduleSelectedClone.time.length < 8 && this.haveTimess) || (this.scheduleSelectedClone.time.length < 5 && !this.haveTimess))
    ) {
      this.scheduleSelectedClone.time = '0' + this.scheduleSelectedClone.time;
    }
    if (this.scheduleSelectedClone && this.scheduleSelectedClone.item7 == '' && this.scheduleSelectedClone.time == '') {
      this.scheduleSelectedClone.item7 = '無表示';
    }
    if (this.scheduleSelected && this.scheduleSelected.isDelete) {
      dataSend = 'undelete';
    }
    if (this.scheduleSelected && this.scheduleSelected.delete) {
      dataSend = 'disableDelete';
    }
    this.dataService.sendData(['enableEdit', dataSend]);
  }

  /**
   * checkBeforeUpdate
   */
  checkBeforeUpdate(): void {
    const dateNow = new Date();
    const now = moment(dateNow)
      .format(this.formatTime)
      .replace(/:?/g, '');
    const timeInt = parseInt(now) + (this.formatTime == 'HH:mm:ss' ? this.timeAdd * 10000 : this.timeAdd * 100);
    const scheduleArray = JSON.parse(JSON.stringify(this.scheduleInsertArray));
    const scheduleEditArray = JSON.parse(JSON.stringify(this.scheduleEditArray));
    const scheduleDeleteArray = JSON.parse(JSON.stringify(this.scheduleDeleteArray));
    let invalid3Min = false;
    let timeCheck3Min =
      parseInt(
        moment(dateNow)
          .add(3, 'minute')
          .format(this.formatTime)
          .replace(/:?/g, '')
      ) + (this.formatTime == 'HH:mm:ss' ? this.timeAdd * 10000 : this.timeAdd * 100);
    let timeCheck1Min =
      parseInt(
        moment(dateNow)
          .add(1, 'minute')
          .format(this.formatTime)
          .replace(/:?/g, '')
      ) + (this.formatTime == 'HH:mm:ss' ? this.timeAdd * 10000 : this.timeAdd * 100);
    for (const scheduleTmp of scheduleEditArray) {
      if (Object.keys(scheduleTmp).length > 2 && !(Object.keys(scheduleTmp).length == 3 && scheduleTmp.hold != undefined)) {
        scheduleArray.push(this.scheduleOperationManagerService.listScheduleOperationFromAPI.entry[scheduleTmp.key - 1]);
      }
    }
    scheduleArray.push(...scheduleDeleteArray);
    for (const item of scheduleArray) {
      if (item.index <= 0 && (item.isDelete || item.isDeleteRowInsert)) {
        continue;
      }
      const timeRow = parseInt(item.time.replace(/:?/g, ''));
      if (timeRow <= timeCheck1Min) {
        this.handleShowMessage('error', 'time-out');
        return;
      } else if (timeRow <= timeCheck3Min) {
        invalid3Min = true;
      }
    }
    if (invalid3Min) {
      this.dialogService.showDialog(
        DialogConfirmComponent,
        {
          data: {
            text: this.translateService.instant(`schedule-operation-manager.confirm-time`),
            button1: this.translateService.instant('timetable-editor.yes'),
            button2: this.translateService.instant('timetable-editor.btn-no')
          }
        },
        result => {
          if (!result) {
            return;
          } else {
            this.updateData();
          }
        }
      );
    } else {
      this.updateData();
    }
  }
  /**
   * update data
   */
  public updateData() {
    this.tenantName = this.commonObject.tenantName;
    let jsonAdd, jsonMod;
    if (this.scheduleInsertArray && this.scheduleInsertArray.length > 0) {
      jsonAdd = {
        update_type: 'add',
        added_entry: [],
        account: this.tenantName.toUpperCase()
      };
      const scheduleInsertArray = JSON.parse(JSON.stringify(this.scheduleInsertArray));
      for (const tmpInsert of scheduleInsertArray) {
        if (tmpInsert.suspension) {
          tmpInsert.item6 = this.translateService.instant('schedule-operation-manager.temporary-suspension');
        } else if (!tmpInsert.item6 || !(tmpInsert.item6 == this.suspension || tmpInsert.item6.toLowerCase() == 'suspension')) {
          tmpInsert.item6 = '';
        }
        delete tmpInsert.suspension;
        delete tmpInsert.index;
        delete tmpInsert.key;
        delete tmpInsert.isEdit;
        delete tmpInsert.notIn35Min;
        delete tmpInsert.isFirstEdit;
        delete tmpInsert.checkTime;
        delete tmpInsert.isEditHold;
        delete tmpInsert.isEditPriority;
        delete tmpInsert.isEditSuspension;
        delete tmpInsert.itemEdit;
        tmpInsert.color = {};
        tmpInsert.blink = '';
        if (tmpInsert.priority && this.getColorByItem8('priority')) {
          let dataColor = this.getColorByItem8('priority');
          tmpInsert.blink = dataColor.blinking ? (dataColor.object == 'time' ? '2' : '1') : '';
          tmpInsert.color = this.getColorToUpdate(dataColor);
        } else if (tmpInsert.hold && this.getColorByItem8('delay')) {
          let dataColor = this.getColorByItem8('delay');
          tmpInsert.blink = dataColor.blinking ? (dataColor.object == 'time' ? '2' : '1') : '';
          tmpInsert.color = this.getColorToUpdate(dataColor);
        } else if (tmpInsert.item8 && this.getColorByItem8(tmpInsert.item8)) {
          let dataColor = this.getColorByItem8(tmpInsert.item8);
          tmpInsert.blink = dataColor.blinking ? (dataColor.object == 'time' ? '2' : '1') : '';
          tmpInsert.color = this.getColorToUpdate(dataColor);
        }
        if (!tmpInsert.isDelete && !tmpInsert.isDeleteRowInsert) {
          jsonAdd.added_entry.push(tmpInsert);
        }
      }
    }
    if (
      (this.scheduleEditArray && this.scheduleEditArray.length > 0) ||
      (this.scheduleDeleteArray && this.scheduleDeleteArray.length > 0)
    ) {
      jsonMod = {
        update_type: 'modify',
        modify_info: [],
        account: this.tenantName.toUpperCase()
      };
      const scheduleEditArray = JSON.parse(JSON.stringify(this.scheduleEditArray));
      for (const tmpEdit of scheduleEditArray) {
        if (Object.keys(tmpEdit).length > 2) {
          if (tmpEdit.priority) {
            let dataColor = this.getColorByItem8('priority');
            tmpEdit.blink = dataColor?.blinking ? (dataColor.object == 'time' ? '2' : '1') : '';
            tmpEdit.color = this.getColorToUpdate(dataColor);
          } else if (tmpEdit.hold) {
            let dataColor = this.getColorByItem8('delay');
            tmpEdit.blink = dataColor?.blinking ? (dataColor.object == 'time' ? '2' : '1') : '';
            tmpEdit.color = this.getColorToUpdate(dataColor);
          } else if (tmpEdit.item8 != undefined) {
            let dataColor = this.getColorByItem8(
              this.scheduleOperationManagerService.listScheduleOperationFromAPI.entry[tmpEdit.key - 1].item8
            );
            tmpEdit.blink = dataColor?.blinking ? (dataColor.object == 'time' ? '2' : '1') : '';
            tmpEdit.color = this.getColorToUpdate(dataColor);
          }
          if (_.isEmpty(tmpEdit.color) && (tmpEdit.priority != undefined || tmpEdit.hold != undefined || tmpEdit.item8 != undefined)) {
            if (this.scheduleOperationManagerService.listScheduleOperationFromAPI.entry[tmpEdit.key - 1].priority) {
              let dataColor = this.getColorByItem8('priority');
              tmpEdit.blink = dataColor?.blinking ? (dataColor.object == 'time' ? '2' : '1') : '';
              tmpEdit.color = this.getColorToUpdate(dataColor);
            } else if (this.scheduleOperationManagerService.listScheduleOperationFromAPI.entry[tmpEdit.key - 1].hold) {
              let dataColor = this.getColorByItem8('delay');
              tmpEdit.blink = dataColor?.blinking ? (dataColor.object == 'time' ? '2' : '1') : '';
              tmpEdit.color = this.getColorToUpdate(dataColor);
            } else if (this.scheduleOperationManagerService.listScheduleOperationFromAPI.entry[tmpEdit.key - 1].item8 != undefined) {
              let dataColor = this.getColorByItem8(
                this.scheduleOperationManagerService.listScheduleOperationFromAPI.entry[tmpEdit.key - 1].item8
              );
              tmpEdit.blink = dataColor?.blinking ? (dataColor.object == 'time' ? '2' : '1') : '';
              tmpEdit.color = this.getColorToUpdate(dataColor);
            }
          } else if (_.isEmpty(tmpEdit.color) && tmpEdit.priority == undefined && tmpEdit.hold == undefined && tmpEdit.item8 == undefined) {
            tmpEdit.color = this.scheduleOperationManagerService.listScheduleOperationFromAPI.entry[tmpEdit.key - 1].color;
            tmpEdit.blink = this.scheduleOperationManagerService.listScheduleOperationFromAPI.entry[tmpEdit.key - 1].blink;
          }
          if (tmpEdit.suspension !== undefined) {
            if (tmpEdit.suspension) {
              tmpEdit.item6 = this.translateService.instant('schedule-operation-manager.temporary-suspension');
            } else if (!tmpEdit.item6 || !(tmpEdit.item6 == this.suspension || tmpEdit.item6.toLowerCase() == 'suspension')) {
              tmpEdit.item6 = '';
            }
            delete tmpEdit.suspension;
          }
          delete tmpEdit.key;
          delete tmpEdit.notIn35Min;
          delete tmpEdit.checkTime;
          delete tmpEdit.itemEdit;
          jsonMod.modify_info.push(tmpEdit);
        }
      }
      for (const tmpDelete of this.scheduleDeleteArray) {
        if (tmpDelete.index > 0) {
          jsonMod.modify_info.push({ index: tmpDelete.index, delete: true });
        }
      }
    }
    forkJoin(
      [
        jsonAdd?.added_entry.length > 0 ? this.apiCustomerService.updateDataScheduleOperation(this.apiUpdateData, jsonAdd) : of({}),
        jsonMod?.modify_info.length > 0 ? this.apiCustomerService.updateDataScheduleOperation(this.apiUpdateData, jsonMod) : of({})
      ],
      (resAdd, resMod) => {
        return {
          resAdd: resAdd,
          resMod: resMod
        };
      }
    ).subscribe(
      data => {
        if (jsonAdd?.added_entry.length > 0 || jsonMod?.modify_info.length > 0) {
          this.reloadData(true);
        }
      },
      err => {
        this.dialogService.showDialog(DialogMessageComponent, {
          data: {
            title: this.translateService.instant('dialog-error.title'),
            text: this.translateService.instant('schedule-operation-manager.update-failed')
          }
        });
      }
    );
  }

  convertViewData(data) {
    if (!data) {
      return '';
    }
    const dataArrTime = data.split(':');
    if (
      (((data.length == 8 || data.length == 7) && dataArrTime.length == 3) ||
        ((data.length == 5 || data.length == 4) && dataArrTime.length == 2)) &&
      !isNaN(Number(dataArrTime[0]))
    ) {
      let hh = parseInt(dataArrTime[0]) > 23 ? dataArrTime[0] - 24 : dataArrTime[0];
      hh = (hh + '').length == 1 ? '0' + hh : hh;
      return dataArrTime.length == 2 ? hh + ':' + dataArrTime[1] : hh + ':' + dataArrTime[1] + ':' + dataArrTime[2];
    } else {
      return data;
    }
  }
  openDialogMessageOperation() {
    this.dialogService.showDialog(DialogMessageOperationComponent, { data: {}, maxHeight: '90vh' }, result => {
      if (result == undefined) {
        return;
      }
    });
  }
  /**
   * hide
   * @param event
   */
  public hide(event): void {
    this.nameDisplayClone = undefined;
  }

  /**
   * edit row display
   * @param label
   */
  public editRowDisplay(label): void {
    if (!this.isEditRow) {
      return;
    }
    this.nameDisplayClone = label;
  }

  /**
   *
   * @param field
   */
  public onChangeFieldRow(field): void {
    if (this.scheduleSelectedClone.index >= 0) {
      this.scheduleEdit[field] = this.scheduleSelectedClone[field];
    }
  }

  private operationInformationSetting(): void {
    // open popup
    this.dialogService.showDialog(DialogOperationInformationSettingScheduleComponent, { data: {} }, result => {
      if (result) {
      }
    });
  }

  /**
   * open dynamic message
   */
  private openDynamicMessage() {
    if (this.isEditDynamicMessageMode || this.isEditEmergencyMode) {
      return;
    }
    if (this.devices.length == 0) {
      this.dialogService.showDialog(DialogMessageComponent, {
        data: {
          title: this.translateService.instant('dialog-message.error-title'),
          text: this.translateService.instant('dialog-message.timetable-operation.choose-devices')
        }
      });
      return;
    }
    this.dynamicMessages = [];
    this.isEditDynamicMessageMode = true;
    this.updateStateItemOnMenu.next();
    const currentDate = this.getCurrentDateByTimeZone(false);
    this.dynamicMessageService
      .getDynamicMessageForMultiDeviceByDeviceIdSchedule(
        this.devices.map(device => device.id),
        currentDate
      )
      .subscribe(
        data => {
          this.dynamicMessages = this.handleDataDynamicMessage(data as any);
          this.handleShowColumnTextAndMedia();
          this.clearDataMediaDropToDynamicMessages();
          this.oldDynamicMessages = _.cloneDeep(this.dynamicMessages);
        },
        () => this.handleErrorFromApi()
      );
  }

  /**
   * handle error from Api
   *
   * @param error
   */
  private handleErrorFromApi() {
    this.unSubAPIPending();
    this.dialogService.showDialog(DialogMessageComponent, {
      data: {
        title: this.translateService.instant('dialog-message.error-title'),
        text: this.translateService.instant('dialog-message.error')
      }
    });
  }

  /**
   * clear data media drop to dynamic message
   */
  private clearDataMediaDropToDynamicMessages(): void {
    this.mediaFilesDroppedOperation = new Array();
    this.filesData = [];
    this.mediaIdsToDelete = new Array();
    this.dynamicMessages.forEach(dynamicMessage => (dynamicMessage.uuidV4Image = ''));
  }

  /**
   * Handle show hide column text and media
   */
  private handleShowColumnTextAndMedia(): void {
    this.isOnlyTextArea = this.dynamicMessages?.every(dynamicMessage => dynamicMessage.textArea != null);
    this.isOnlyPictureArea = this.dynamicMessages?.every(dynamicMessage => dynamicMessage.pictureArea != null);
  }

  /**
   *Handle data dynamic message
   *
   * @param dynamicMessagesData
   */
  private handleDataDynamicMessage(dynamicMessagesData: DynamicMessageSchedule[]): DynamicMessageSchedule[] {
    return dynamicMessagesData
      .map(dynamicMessageData => {
        return this.convertDataDynamicMessageFromServer(dynamicMessageData);
      })
      .sort(
        (dv1, dv2) =>
          +dv1.device.id - +dv2.device.id || +dv1.textArea?.id - +dv2.textArea?.id || +dv1.pictureArea?.id - +dv2.pictureArea?.id
      );
  }

  /**
   * convert data dynamic message
   *
   * @param dynamicMessageData
   * @returns
   */
  private convertDataDynamicMessageFromServer(dynamicMessageData: any) {
    if (!dynamicMessageData) {
      return;
    }
    let dynamicMessage = new DynamicMessageSchedule();
    dynamicMessage.id = dynamicMessageData['id'];
    dynamicMessage.device = this.devices.find(device => device.id == dynamicMessageData['deviceId']);
    if (dynamicMessageData['textArea']) {
      dynamicMessage.textArea = Helper.convertDataTextArea(dynamicMessageData['textArea']);
      dynamicMessage.message = dynamicMessageData['message'] ?? '';
    }
    if (dynamicMessageData['pictureArea']) {
      dynamicMessage.pictureArea = Helper.convertDataPictureArea(dynamicMessageData['pictureArea']);
      dynamicMessage.media = dynamicMessageData['media'] ?? null;
    }
    return dynamicMessage;
  }

  /**
   * Get current date by time zone
   *
   * @param isGetHours
   * @returns
   */
  private getCurrentDateByTimeZone(isGetHours: boolean): string {
    var offsetHour = 0;
    var offsetMinute = 0;
    var setting = this.commonObject.setting;
    if (setting) {
      offsetHour = setting.timezone.offsetHour;
      offsetMinute = setting.timezone.offsetMinute;
    }
    return moment
      .utc()
      .add(offsetHour, 'hour')
      .add(offsetMinute, 'minute')
      .format(isGetHours ? Constant.FORMAT_HOURS : Constant.FORMAT_DATE);
  }

  /**
   * change dynamic message by enter key
   *
   * @param dynamicMessage
   * @param index
   * @param $event
   * @returns
   */
  public changeDynamicMessageEnterKey(dynamicMessage: DynamicMessage, index: number, $event: any) {
    if (!$event) {
      $event.preventDefault();
      return;
    }
    // key enter
    if ($event.keyCode == Constant.ENTER_KEY_CODE) {
      if (dynamicMessage.message.length > Constant.MAX_LENGTH_VALUE) {
        this.propertiesName.dynamicMessage = this.translateService.instant('dialog-message.timetable-operation.dynamic-message');
        this.dialogService.showDialog(
          DialogMessageComponent,
          {
            data: {
              title: this.translateService.instant('dialog-message.error-title'),
              text: Helper.getErrorMessage(
                ErrorEnum.MAX_LENGTH,
                this.propertiesName.dynamicMessage,
                Constant.MAX_LENGTH_VALUE,
                this.translateService
              )
            },
            autoFocus: false
          },
          () => {
            document.getElementById(`dynamicMessageInput${index}`).focus();
          }
        );
        return;
      }
      dynamicMessage.isEdit = false;
    }
  }

  /**
   * change dynamic message by keyboard
   *
   * @param index
   */
  public changeDynamicMessage(index: number): void {
    this.dynamicMessages[index].isChanged = this.oldDynamicMessages[index].message != this.dynamicMessages[index].message;
  }

  /**
   * open emergency
   */
  private openEmergency() {
    if (this.isEditDynamicMessageMode || this.isEditEmergencyMode) {
      return;
    }
    if (this.devices.length <= 0) {
      this.dialogService.showDialog(DialogMessageComponent, {
        data: {
          title: this.translateService.instant('dialog-message.error-title'),
          text: this.translateService.instant('dialog-message.timetable-operation.choose-devices')
        }
      });
      return;
    }
    this.openDialogEmergencyMode();
  }

  /**
   * open popup emergency mode
   */
  private openDialogEmergencyMode() {
    this.dialogService.showDialog(DialogEmergencyModeComponent, {}, result => {
      // click Cancel
      if (result.length == 0) {
        return;
      }
      // click Off
      if (!result) {
        this.updateEmergencyModeForDevices(this.devices, false);
        return;
      }
      // click Edit
      this.isEditEmergencyMode = true;
      this.updateStateItemOnMenu.next();
      this.emergencyDataService.getEmergencyScheduleData().subscribe(
        data => {
          if (data.length == 0) {
            this.emergencyData = new EmergencyData(Constant.EMPTY, -1, Constant.EMPTY);
            this.emergencyMediaIdOld = this.emergencyData.emergencyImageId;
            return;
          }
          this.emergencyData = data[0];
          if (this.emergencyData.emergencyImageId == -1 || !this.emergencyData.emergencyImageId || !this.emergencyData.media) {
            this.emergencyData.media = null;
            this.emergencyData.urlImage = Constant.EMPTY;
          }
          this.emergencyMediaIdOld = this.emergencyData.emergencyImageId;
        },
        () => this.handleErrorFromApi()
      );
    });
  }

  /**
   * update emergency mode for devices
   *
   * @param checkedDevices
   * @param isOnEmergencyMode
   */
  private updateEmergencyModeForDevices(checkedDevices: DeviceOperation[], isOnEmergencyMode: boolean) {
    const registrationIds = checkedDevices.map(device => device.registrationId);
    if (isOnEmergencyMode) {
      if (!this.emergencyData.emergencyImageId) {
        this.mediaService.uploadEmergencyMedia(this.emergencyData.media as any).subscribe(
          mediaResponse => {
            if (!mediaResponse) {
              this.handleErrorFromApi();
              return;
            }
            if (mediaResponse.id == Constant.ERROR_CODE_MAX_LENGTH_NAME) {
              this.dialogService.showDialog(DialogMessageComponent, {
                data: {
                  title: this.translateService.instant('dialog-message.error-title'),
                  text: Helper.formatString(
                    this.translateService.instant('timetable-operation-manager.message.length-file'),
                    `${Constant.MAX_LENGTH_MEDIA_NAME}`
                  )
                }
              });
              return;
            }
            this.emergencyData.media = mediaResponse;
            this.emergencyData.emergencyImageId = mediaResponse.id as number;
            this.emergencyData.urlImage = mediaResponse.url;
            this.emergencyMediaIdOld = this.emergencyData.emergencyImageId;
            this.handleDataEmergency(registrationIds);
          },
          error => this.handleErrorFromCustomerApi()
        );
      } else {
        // delete old emergency image after clear in GUI
        if (this.emergencyMediaIdOld && this.emergencyMediaIdOld != -1 && this.emergencyMediaIdOld != this.emergencyData.emergencyImageId) {
          this.mediaService.deleteEmergencyImage(this.emergencyMediaIdOld).toPromise();
        }
        this.handleDataEmergency(registrationIds);
      }
    } else {
      const payload = {
        id: registrationIds,
        timeoutSec: Constant.DEFAULT_TIMEOUT
      };
      this.deviceService.offEmergencyMode(payload).subscribe(
        async () => {
          this.showDialogSuccess('schedule-operation-manager.emergency-off');
        },
        error => {
          this.dialogService.showDialog(DialogMessageComponent, {
            data: {
              title: this.translateService.instant('dialog-error.title'),
              text: this.translateService.instant('dialog-error.msg')
            }
          });
        }
      );
    }
  }

  /**
   * Get devices success for delivery
   *
   * @param devices
   * @param isDynamicMessage
   * @param payloadData
   * @returns
   */
  private async getDevicesSuccessForDelivery(devices: Array<any>, isDynamicMessage: boolean, payloadData?: any): Promise<any> {
    let devicesSave = [];
    if (!devices) {
      return devicesSave;
    }
    await Promise.all(
      devices.map(async checkedDevice => {
        const payloadRealtime = {
          device: isDynamicMessage ? checkedDevice.registrationId : checkedDevice
        };
        let dataPayload;
        if (payloadData) {
          dataPayload = isDynamicMessage
            ? [...payloadData['dynamic_message_list']].find(data => data['device'] == payloadRealtime.device)['dynamic_message']
            : payloadData;
        }
        try {
          await this.handleCallApiCustomer(payloadRealtime, checkedDevice, dataPayload).then(data => {
            if (data) {
              devicesSave.push(data);
            }
          });
        } catch (error) {
          //@ts-ignore
        }
      })
    );
    return devicesSave;
  }

  /**
   * handle call api customer
   * @param payloadRealtime
   * @param checkedDeviceSave
   * @param payloadData
   * @returns
   */
  async handleCallApiCustomer(payloadRealtime, checkedDeviceSave, payloadData?: any) {
    try {
      return await this.asyncInterval(payloadRealtime, checkedDeviceSave, payloadData);
    } catch (error) {
      //@ts-ignore
    }
  }

  /**
   * Get data need check
   *
   * @param payloadData
   * @returns APINeedCheckEnum
   */
  private getDataNeedCheck(payloadData: any): APIEnum {
    if (!payloadData) {
      return APIEnum.OFF_EMERGENCY;
    }
    if (Array.isArray(payloadData)) {
      return APIEnum.DYNAMIC_MESSAGE;
    }
    return APIEnum.ON_EMERGENCY;
  }

  /**
   * async interval
   * @param payloadRealtime
   * @param checkedDeviceSave
   * @param payloadData
   * @param triesCallAPI
   * @returns
   */
  async asyncInterval(payloadRealtime, checkedDeviceSave, payloadData?: any, triesCallAPI = Constant.NUMBERS_OF_API_CALLS) {
    return new Promise((resolve, reject) => {
      let checkNum = this.getDataNeedCheck(payloadData);
      const interval = setInterval(async () => {
        this.apiCustomerService
          .getTimetableRealtimeStatus(payloadRealtime)
          .pipe(takeUntil(this.ngUnsubscribe))
          .subscribe(
            realtimeData => {
              switch (checkNum) {
                case APIEnum.OFF_EMERGENCY:
                  if (
                    realtimeData &&
                    !realtimeData[Constant.EMERGENCY_MESSAGE][Constant.IMAGE_ATTRIBUTE] &&
                    !realtimeData[Constant.EMERGENCY_MESSAGE][Constant.MESSAGE_ATTRIBUTE]
                  ) {
                    resolve(checkedDeviceSave);
                    clearInterval(interval);
                  }
                  break;
                case APIEnum.DYNAMIC_MESSAGE:
                  if (realtimeData && _.isEqual(realtimeData[Constant.DYNAMIC_MESSAGE], payloadData)) {
                    resolve(checkedDeviceSave);
                    clearInterval(interval);
                  }
                  break;
                case APIEnum.ON_EMERGENCY:
                  if (
                    realtimeData &&
                    realtimeData[Constant.EMERGENCY_MESSAGE][Constant.IMAGE_ATTRIBUTE] == payloadData[Constant.IMAGE_ATTRIBUTE] &&
                    realtimeData[Constant.EMERGENCY_MESSAGE][Constant.MESSAGE_ATTRIBUTE] == payloadData[Constant.MESSAGE_ATTRIBUTE]
                  ) {
                    resolve(checkedDeviceSave);
                    clearInterval(interval);
                  }
                  break;
                default:
                  break;
              }
              if (triesCallAPI <= 1) {
                reject();
                resolve(undefined);
                clearInterval(interval);
                this.executingService.executed();
              }
              triesCallAPI--;
            },
            () => {
              // call api error
              triesCallAPI--;
              if (triesCallAPI <= 0) {
                reject();
                resolve(undefined);
                clearInterval(interval);
                this.executingService.executed();
              } else {
                this.executingService.executing();
              }
            }
          );
      }, Constant.NUMBER_MILLISECONDS_CALL_API);
    });
  }

  /**
   * handle error from customer api
   *
   * @param errorApi
   * @param error
   */
  private handleErrorFromCustomerApi() {
    this.unSubAPIPending();
    this.dialogService.showDialog(DialogMessageComponent, {
      data: {
        title: this.translateService.instant('dialog-message.error-title'),
        text: this.translateService.instant('dialog-message.error')
      }
    });
  }

  /**
   * Handle data emergency
   *
   * @param registrationIds
   */
  private handleDataEmergency(registrationIds: string[]): void {
    this.mediaService.getMediaUrlToDelivery(this.emergencyData.media ? this.emergencyData.media.id : -1).subscribe(
      dataResponse => {
        const payload = {
          id: registrationIds,
          message: Helper.encodeHTML(this.emergencyData.emergencyText),
          image: dataResponse['url'],
          timeoutSec: Constant.DEFAULT_TIMEOUT,
          req_id: uniqueId()
        };
        if (this.emergencyData.emergencyText == '' && payload[Constant.IMAGE_ATTRIBUTE] == '') {
          this.dialogService.showDialog(DialogMessageComponent, {
            data: {
              title: this.translateService.instant('dialog-message.error-title'),
              text: this.translateService.instant('dialog-message.timetable-operation.text-image-not-empty')
            }
          });
          return;
        }
        this.deviceService.onEmergencyMode(payload).subscribe(
          async () => {
            this.saveEmergency();
          },
          error => this.handleErrorFromCustomerApi()
        );
      },
      error => this.handleErrorFromCustomerApi()
    );
  }

  private showDialogSuccess(msg: any) {
    this.unSubAPIPending();
    this.dialogService.showDialog(DialogMessageComponent, {
      data: {
        title: this.translateService.instant('dialog-confirm.title'),
        text: this.translateService.instant(msg)
      }
    });
  }
  /**
   * unSubAPIPending
   */
  private unSubAPIPending(): void {
    this.ngUnsubscribe.next();
    // This completes the subject properlly.
    this.ngUnsubscribe.complete();
  }
  /**
   * update emergency mode
   *
   * @param registrationIds
   * @param isOnEmergency
   * @returns
   */
  private updateEmergencyMode(registrationIds: string[], isOnEmergency: boolean) {
    if (!registrationIds || registrationIds.length == 0) {
      return;
    }
    this.deviceService.updateEmergencyMode(registrationIds, isOnEmergency).subscribe(
      deviceIds => {
        if (!isOnEmergency) {
          this.executingService.executed();
        }
        deviceIds.forEach(deviceId => {
          this.devices.find(device => device.id == deviceId).isOnEmergency = isOnEmergency;
        });
      },
      () => this.handleErrorFromApi()
    );
  }

  /**
   * save emergency data
   */
  private saveEmergency() {
    let emergencyUpdate = new EmergencyData(this.emergencyData.emergencyText, this.emergencyData.emergencyImageId);
    emergencyUpdate.id = this.emergencyData.id;
    this.emergencyDataService.saveSchedule(emergencyUpdate).subscribe(
      data => {
        this.emergencyData.id = data.id;
        this.emergencyMediaIdOld = this.emergencyData.emergencyImageId;
        this.showDialogSuccess('schedule-operation-manager.emergency-on');
      },
      () => this.handleErrorFromApi()
    );
  }

  /**
   * allow drop
   *
   * @param e
   */
  public allowDrop(e) {
    e.preventDefault();
  }

  /**
   * drop picture for emergency data
   *
   * @param $event
   * @returns
   */
  public dropPictureForEmergency($event: any) {
    if (
      $event.dataTransfer.getData(Constant.MEDIA_VALUE) == '' ||
      JSON.parse($event.dataTransfer.getData(Constant.IS_MEDIA_IN_STATION_CONTENT_FOLDER)) ||
      JSON.parse($event.dataTransfer.getData(Constant.IS_MEDIA_IN_LCD_LAYOUT_EDITOR)) ||
      JSON.parse($event.dataTransfer.getData(Constant.FOLDER_INDEX_WORD_EDITOR))
    ) {
      return;
    }
    $event.preventDefault();
    var mediaObject = JSON.parse($event.dataTransfer.getData(Constant.MEDIA_VALUE));
    let media = Helper.convertMediaData(mediaObject);
    if (!Helper.isImage(media)) {
      this.dialogService.showDialog(DialogMessageComponent, {
        data: {
          title: this.translateService.instant('dialog-message.error-title'),
          text: this.translateService.instant('dialog-message.timetable-operation.invalid-file')
        }
      });
      return;
    }
    media.name = Helper.convertMediaNameBackWard(media.name, media.mediaNameEncode);
    this.emergencyData.media = media;
    this.emergencyData.urlImage = media.url;
    this.emergencyData.emergencyImageId = media.id;
  }

  /**
   * Drop media from pc to emergency
   *
   * @param mediaFile
   * @returns
   */
  public async dropMediaFromPCToEmergency(mediaFile: any) {
    if (!Helper.isImageFile(mediaFile[Constant.FILE_MEDIA_OBJECT])) {
      this.dialogService.showDialog(DialogMessageComponent, {
        data: {
          title: this.translateService.instant('dialog-message.error-title'),
          text: this.translateService.instant('dialog-message.timetable-operation.invalid-file')
        }
      });
      return;
    }

    // handle file drop
    let fileDrop = mediaFile[0][0];
    const type = mediaFile[Constant.FILE_MEDIA_OBJECT][Constant.TYPE_ATTRIBUTE];
    // file is pdf
    if (type.toLowerCase() == TypeMediaFileEnum.PDF) {
      const numberOfPage = await this.mediaService
        .getNumberOfPagePdf(new File([fileDrop], fileDrop[Constant.NAME_ATTRIBUTE]))
        .toPromise()
        .catch(error => {
          Helper.handleError(error, this.translateService, this.dialogService);
          return 0;
        });
      if (numberOfPage > 1) {
        this.dialogService.showDialog(
          DialogConfirmComponent,
          {
            data: {
              text: this.translateService.instant('dialog-confirm.timetable-operation-manager.confirm-convert-file-pdf'),
              button1: this.translateService.instant('dialog-confirm.timetable-operation-manager.button-1'),
              button2: this.translateService.instant('dialog-confirm.timetable-operation-manager.button-2')
            }
          },
          result => {
            if (!result) {
              return;
            }
            this.handleAfterDropMediaToEmergency(fileDrop, mediaFile);
          }
        );
      } else if (numberOfPage == 1) {
        this.handleAfterDropMediaToEmergency(fileDrop, mediaFile);
      }
    } else {
      this.handleAfterDropMediaToEmergency(fileDrop, mediaFile);
    }
  }

  /**
   * handle After Drop Media To Emergency
   * @param fileDrop
   * @param mediaFile
   * @returns
   */
  private async handleAfterDropMediaToEmergency(fileDrop: any, mediaFile: any): Promise<void> {
    let fileFromPC: Media = null;
    const type = mediaFile[Constant.FILE_MEDIA_OBJECT][Constant.TYPE_ATTRIBUTE];
    // file is pdf
    if (type.toLowerCase() == TypeMediaFileEnum.PDF) {
      fileFromPC = await this.mediaService
        .convertPDFToImage(new File([fileDrop], fileDrop[Constant.NAME_ATTRIBUTE]), FolderNameDropPDFEnum.EMERGENCY)
        .toPromise()
        .catch(() => {
          return null;
        });

      if (fileFromPC == null) {
        return;
      }
    } else {
      let imageInfo = await this.getImageInformation(fileDrop);
      // validate unsupported file format
      if (imageInfo[Constant.ERROR_ELEMENT]) {
        this.dialogService.showDialog(DialogMessageComponent, {
          data: {
            title: this.translateService.instant('dialog-message.error-title'),
            text: this.translateService.instant('dialog-error.unsupported-file-format')
          }
        });
        return;
      }
    }
    this.emergencyData.emergencyImageId = undefined;
    this.emergencyData.urlImage = fileFromPC ? fileFromPC.url : mediaFile[Constant.FILE_MEDIA_OBJECT][Constant.URL_ATTRIBUTE];
    this.emergencyData.media = fileDrop;
    this.emergencyData.media.url = fileFromPC ? fileFromPC.url : mediaFile[Constant.FILE_MEDIA_OBJECT][Constant.URL_ATTRIBUTE];
  }

  /**
   * Drop media from pc
   *
   * @param file
   * @param dynamicMessage
   * @param indexDynamic
   */
  public async dropMediaFromPCDynamicMessage(file: any, dynamicMessage: DynamicMessage, indexDynamic: number): Promise<void> {
    if (dynamicMessage.textArea) {
      return;
    }
    if (!Helper.isImageFile(file[Constant.FILE_MEDIA_OBJECT])) {
      this.dialogService.showDialog(DialogMessageComponent, {
        data: {
          title: this.translateService.instant('dialog-message.error-title'),
          text: this.translateService.instant('dialog-message.timetable-operation.invalid-file')
        }
      });
      return;
    }
    // handle file drop
    let fileDrop = file[0][0];
    const mediaType = file[Constant.FILE_MEDIA_OBJECT][Constant.TYPE_ATTRIBUTE];
    const fileName = `${Constant.IMAGE_NAME_DROP_MEDIA}_${moment(new Date()).format(Constant.FORMAT_DATE_DROP_MEDIA)}.${mediaType}`;
    // file is pdf
    if (mediaType.toLowerCase() == TypeMediaFileEnum.PDF) {
      const numberOfPage = await this.mediaService
        .getNumberOfPagePdf(new File([fileDrop], fileDrop[Constant.NAME_ATTRIBUTE]))
        .toPromise()
        .catch(error => {
          Helper.handleError(error, this.translateService, this.dialogService);
          return 0;
        });
      if (numberOfPage > 1) {
        this.dialogService.showDialog(
          DialogConfirmComponent,
          {
            data: {
              text: this.translateService.instant('dialog-confirm.timetable-operation-manager.confirm-convert-file-pdf'),
              button1: this.translateService.instant('dialog-confirm.timetable-operation-manager.button-1'),
              button2: this.translateService.instant('dialog-confirm.timetable-operation-manager.button-2')
            }
          },
          result => {
            if (!result) {
              return;
            }
            this.handleAfterDropMediaToDynamicMessages(mediaType, fileDrop, fileName, dynamicMessage, file, indexDynamic);
          }
        );
      } else if (numberOfPage == 1) {
        this.handleAfterDropMediaToDynamicMessages(mediaType, fileDrop, fileName, dynamicMessage, file, indexDynamic);
      }
    } else {
      this.handleAfterDropMediaToDynamicMessages(mediaType, fileDrop, fileName, dynamicMessage, file, indexDynamic);
    }
  }

  /**
   * handle After Drop Media To DynamicMessages
   * @param mediaType
   * @param fileDrop
   * @param fileName
   * @param dynamicMessage
   * @param file
   * @param indexDynamic
   * @returns
   */
  private async handleAfterDropMediaToDynamicMessages(
    mediaType: any,
    fileDrop: any,
    fileName: any,
    dynamicMessage: DynamicMessage,
    file: any,
    indexDynamic: number
  ): Promise<void> {
    let fileFromPC: Media = null;
    // file is pdf
    if (mediaType.toLowerCase() == TypeMediaFileEnum.PDF) {
      fileFromPC = await this.mediaService
        .convertPDFToImage(new File([fileDrop], fileName), FolderNameDropPDFEnum.DYNAMIC_MESSAGE)
        .toPromise()
        .catch(() => {
          return null;
        });

      if (fileFromPC == null) {
        return;
      }
    } else {
      let imageInfo = await this.getImageInformation(fileDrop);
      // validate unsupported file format
      if (imageInfo[Constant.ERROR_ELEMENT]) {
        this.dialogService.showDialog(DialogMessageComponent, {
          data: {
            title: this.translateService.instant('dialog-message.error-title'),
            text: this.translateService.instant('dialog-error.unsupported-file-format')
          }
        });
        return;
      }
    }
    // get url media to display in GUI
    if (dynamicMessage.media && !dynamicMessage.uuidV4Image) {
      this.mediaIdsToDelete.push(dynamicMessage.media.id);
    }
    let uuid = uniqueId();
    const fileRenamed = new File([fileDrop], uuid);
    let mediaFile = new MediaFileDropped(uuid, fileName);
    const index = this.mediaFilesDroppedOperation?.findIndex(data => data?.uuidV4 == dynamicMessage.uuidV4Image);
    if (index == -1) {
      this.mediaFilesDroppedOperation.push(mediaFile);
      this.filesData.push(fileRenamed);
    } else {
      this.mediaFilesDroppedOperation[index] = mediaFile;
      this.filesData[index] = fileRenamed;
    }
    dynamicMessage.uuidV4Image = uuid;
    let mediaFromPC: Media = new ImageDynamicMessage();
    mediaFromPC.url = fileFromPC ? fileFromPC.url : file[Constant.FILE_MEDIA_OBJECT][Constant.URL_ATTRIBUTE];
    mediaFromPC.type = mediaType;
    dynamicMessage.media = mediaFromPC;
    dynamicMessage.isChanged = this.oldDynamicMessages[indexDynamic].media != dynamicMessage.media;
  }

  /**
   * Get image information
   *
   * @param media
   * @returns
   */
  private getImageInformation(media: any): any {
    return new Promise((resolve, reject) => {
      try {
        const fileReader = new FileReader();
        fileReader.onload = () => {
          const img = new Image();
          img.onload = () => {
            resolve({ width: img.width, height: img.height });
          };
          img.onerror = () => {
            resolve({ error: Constant.ERROR_ELEMENT });
          };
          img.src = fileReader.result as string;
        };
        fileReader.readAsDataURL(media);
      } catch (e) {
        reject(e);
      }
    });
  }

  /**
   * Clear emergency image
   */
  public clearEmergencyImage(): void {
    if (this.emergencyData.urlImage == '') {
      return;
    }
    this.dialogService.showDialog(
      DialogConfirmComponent,
      {
        data: {
          text: this.translateService.instant('dialog-confirm.timetable-operation-manager.want-to-clear-image'),
          button1: this.translateService.instant('dialog-confirm.timetable-operation-manager.button-1'),
          button2: this.translateService.instant('dialog-confirm.timetable-operation-manager.button-2')
        }
      },
      result => {
        if (result) {
          this.emergencyData.media = undefined;
          this.emergencyData.urlImage = '';
          this.emergencyData.emergencyImageId = -1;
        }
      }
    );
  }

  /**
   * edit dynamic message
   *
   * @param dynamicMessage
   */
  public editDynamicMessage(dynamicMessage: DynamicMessage) {
    if (dynamicMessage.pictureArea) {
      return;
    }
    dynamicMessage.isEdit = true;
    if (!dynamicMessage.message) {
      dynamicMessage.message = Constant.EMPTY;
    }
  }

  /**
   * handle delivery dynamic message
   */
  private handleDeliveryDynamicMessage(): void {
    let mediasDynamic = this.dynamicMessages.filter(item => !item[Constant.URL_MEDIA_DROP_PC] && item.media)?.map(dynamic => dynamic.media);
    if (mediasDynamic?.length) {
      const mediaIds = mediasDynamic.map(media => media.id);
      this.mediaService.getMediaUrlsDynamicMessage(mediaIds).subscribe(mediaUrls => {
        // update url to delivery for dynamic message
        if (mediaUrls?.length) {
          mediaIds.forEach((mediaId, index) => {
            const indexDynamic = this.dynamicMessages.findIndex(data => data.media?.id == mediaId);
            if (indexDynamic != -1) {
              this.dynamicMessages[indexDynamic][Constant.URL_MEDIA_DROP_PC] = mediaUrls[index];
            }
          });
        }
        this.handleCallAPIDynamicMessage();
      });
    } else {
      this.handleCallAPIDynamicMessage();
    }
  }

  /**
   * handle call api dynamic message
   */
  private handleCallAPIDynamicMessage(): void {
    const devicesDelivery = [
      ...new Set(this.dynamicMessages?.filter(elememt => elememt.isChanged)?.map(dynamicMessage => dynamicMessage.device))
    ];
    if (!devicesDelivery || !devicesDelivery.length) {
      return;
    }
    const dynamicMessageList = devicesDelivery.map(device => {
      return {
        device: device.registrationId,
        dynamic_message: this.dynamicMessages
          .filter(dynamicMessage => dynamicMessage.device.id == device.id)
          .map(dynamicMessage => {
            if (dynamicMessage.textArea) {
              return {
                area: `${Constant.PREFIX_AREA}${dynamicMessage.textArea.id}`,
                type: Constant.TYPE_DYNAMIC_TEXT,
                message: Helper.encodeHTML(dynamicMessage.message)
              };
            } else if (dynamicMessage.pictureArea) {
              return {
                area: `${Constant.PREFIX_AREA}${dynamicMessage.pictureArea.id}`,
                type: Constant.TYPE_DYNAMIC_IMAGE,
                image: dynamicMessage[Constant.URL_MEDIA_DROP_PC] ?? Constant.EMPTY
              };
            }
          })
      };
    });
    const payload = {
      dynamic_message_list: dynamicMessageList
    };
    this.apiCustomerService.deliveryDynamicMessage(payload).subscribe(
      async () => {
        this.executingService.executing();
        const devicesSave = await this.getDevicesSuccessForDelivery(devicesDelivery, true, payload);
        if (devicesSave.length > 0) {
          this.saveDynamicMessages(this.dynamicMessages, devicesSave, true);
        } else {
          this.showDialogSuccess('schedule-operation-manager.dynamic-message-on');
        }
      },
      error => this.handleErrorFromCustomerApi()
    );
  }

  /**
   * Save dynamic messages
   *
   * @param dynamicMessages
   * @param devicesSave
   * @param isNotLeave
   */
  private saveDynamicMessages(dynamicMessages: Array<DynamicMessageSchedule>, devicesSave?: DeviceOperation[], isNotLeave?: boolean): void {
    // upload file if has image
    if (this.filesData.length) {
      this.mediaService.uploadMediaFromPcToDynamicMessage(this.filesData, this.mediaFilesDroppedOperation).subscribe(
        dataResponse => {
          if (dataResponse) {
            this.handleDataMediaAfterSaved(dataResponse);
          }
          if (this.mediaIdsToDelete.length) {
            this.mediaService.deleteMediasDynamicMessage(this.mediaIdsToDelete).subscribe(
              () => {
                this.clearDataMediaDropToDynamicMessages();
                this.handleSaveDynamicMessage(dynamicMessages, devicesSave, isNotLeave);
              },
              error => Helper.handleError(error, this.translateService, this.dialogService)
            );
          } else {
            this.clearDataMediaDropToDynamicMessages();
            this.handleSaveDynamicMessage(dynamicMessages, devicesSave, isNotLeave);
          }
        },
        error => {
          Helper.handleError(error, this.translateService, this.dialogService);
          this.saveDataSuccess.emit(false);
          return;
        }
      );
    } else {
      this.handleSaveDynamicMessage(dynamicMessages, devicesSave, isNotLeave);
    }
  }

  /**
   * handle save dynamic messages
   *
   * @param dynamicMessages
   * @param devicesSave
   * @param isNotLeave
   */
  private handleSaveDynamicMessage(dynamicMessages: DynamicMessageSchedule[], devicesSave: DeviceOperation[], isNotLeave?: boolean): void {
    const currentDate = this.getCurrentDateByTimeZone(false);
    let dynamicMessagesSave = dynamicMessages.map(dynamicMessage => {
      return {
        id: dynamicMessage.id,
        textArea: dynamicMessage.textArea,
        pictureArea: dynamicMessage.pictureArea,
        deviceId: dynamicMessage.device.id,
        message: dynamicMessage.message,
        mediaId: dynamicMessage.media?.id
      };
    });
    if (devicesSave) {
      const checkedDevicesId = devicesSave.map(device => {
        return device.id;
      });
      dynamicMessagesSave = dynamicMessagesSave.filter(dynamicMessage => checkedDevicesId.find(id => +id == dynamicMessage.deviceId));
    }
    this.dynamicMessageService.saveDynamicMessagesSchedule(dynamicMessagesSave).subscribe(
      () => {
        if (!isNotLeave) {
          this.saveDataSuccess.emit(true);
          return;
        }
        this.dynamicMessageService
          .getDynamicMessageForMultiDeviceByDeviceIdSchedule(
            this.devices.map(device => device.id),
            currentDate
          )
          .subscribe(
            data => {
              this.executingService.executed();
              this.dynamicMessages = this.handleDataDynamicMessage(data as any);
              this.oldDynamicMessages = _.cloneDeep(this.dynamicMessages);
              this.showDialogSuccess('schedule-operation-manager.dynamic-message-on');
            },
            () => {
              this.handleErrorFromApi();
            }
          );
        this.saveDataSuccess.emit(true);
      },
      () => {
        this.saveDataSuccess.emit(false);
        this.handleErrorFromApi();
      }
    );
  }

  /**
   * handle data media after saved
   * @param mediaFiles
   */
  private handleDataMediaAfterSaved(mediaFiles: MediaFileDropped[]): void {
    mediaFiles.forEach((file, index) => {
      const indexDynamic = this.dynamicMessages.findIndex(data => data.uuidV4Image == file.uuidV4);
      if (indexDynamic == -1) {
        return;
      }
      this.dynamicMessages[indexDynamic].media = Helper.convertMediaData(mediaFiles[index].media);
      this.dynamicMessages[indexDynamic][Constant.URL_MEDIA_DROP_PC] = mediaFiles[index].urlMediaDelivery;
    });
  }

  /**
   * delivery
   */
  public delivery() {
    if (this.isEditDynamicMessageMode) {
      // delivery dynamic message
      if (this.dynamicMessages.length == 0) {
        this.dialogService.showDialog(DialogMessageComponent, {
          data: {
            title: this.translateService.instant('dialog-message.error-title'),
            text: this.translateService.instant('dialog-message.timetable-operation.no-dynamic-message')
          }
        });
        return;
      } else if (this.dynamicMessages.some(dynamicMessage => dynamicMessage.message?.length > Constant.MAX_LENGTH_VALUE)) {
        this.propertiesName.dynamicMessage = this.translateService.instant('dialog-message.timetable-operation.dynamic-message');
        this.dialogService.showDialog(DialogMessageComponent, {
          data: {
            title: this.translateService.instant('dialog-message.error-title'),
            text: Helper.getErrorMessage(
              ErrorEnum.MAX_LENGTH,
              this.propertiesName.dynamicMessage,
              Constant.MAX_LENGTH_VALUE,
              this.translateService
            )
          },
          autoFocus: false
        });
        return;
      }
      // upload file if has image
      if (this.filesData.length) {
        this.mediaService.uploadMediaFromPcToDynamicMessage(this.filesData, this.mediaFilesDroppedOperation).subscribe(
          dataResponse => {
            if (dataResponse) {
              this.handleDataMediaAfterSaved(dataResponse);
              this.saveDataSuccess.emit(true);
            }
            if (this.mediaIdsToDelete.length) {
              this.mediaService.deleteMediasDynamicMessage(this.mediaIdsToDelete).subscribe(
                () => {
                  this.clearDataMediaDropToDynamicMessages();
                  this.handleDeliveryDynamicMessage();
                },
                error => Helper.handleError(error, this.translateService, this.dialogService)
              );
            } else {
              this.clearDataMediaDropToDynamicMessages();
              this.handleDeliveryDynamicMessage();
            }
          },
          error => {
            Helper.handleError(error, this.translateService, this.dialogService);
            this.saveDataSuccess.emit(false);
            return;
          }
        );
      } else {
        this.ngUnsubscribe = new Subject<void>();
        this.handleDeliveryDynamicMessage();
      }
    } else if (this.isEditEmergencyMode) {
      // delivery emergency mode
      if (this.emergencyData.emergencyText?.length > Constant.MAX_LENGTH_VALUE) {
        this.propertiesName.emergencyLinkText = this.translateService.instant('dialog-message.timetable-operation.link-text');
        this.dialogService.showDialog(DialogMessageComponent, {
          data: {
            title: this.translateService.instant('dialog-message.error-title'),
            text: Helper.getErrorMessage(
              ErrorEnum.MAX_LENGTH,
              this.propertiesName.emergencyLinkText,
              Constant.MAX_LENGTH_VALUE,
              this.translateService
            )
          }
        });
        return;
      }
      this.ngUnsubscribe = new Subject<void>();
      this.updateEmergencyModeForDevices(this.devices, true);
    }
  }

  /**
   * cancel
   */
  public cancel() {
    if (this.isEditDynamicMessageMode) {
      this.clearDataMediaDropToDynamicMessages();
      this.isEditDynamicMessageMode = false;
      this.dynamicMessages = [];
    } else if (this.isEditEmergencyMode) {
      this.isEditEmergencyMode = false;
    }
    this.updateStateItemOnMenu.next();
  }

  /**
   * getAllTextColor
   */
  private getAllTextColor(): any {
    this.textHighlightSettingService.getAllTextHighLightSetting().subscribe(data => {
      if (!data || !data.length) {
        return;
      }
      this.listDataColor = data.map(d => Helper.convertTextHighlightFromDB(d));
    });
  }

  /**
   * getColorByItem8
   * @param item8
   * @returns
   */
  private getColorByItem8(item8: string): any {
    const colorActives = this.listDataColor.filter(data => data.isActive);
    if (!colorActives.length) {
      return null;
    }
    let titleName = '';
    switch (item8) {
      case '1':
        titleName = 'highlight-1';
        break;
      case '2':
        titleName = 'highlight-2';
        break;
      case '3':
        titleName = 'highlight-3';
        break;
      case 'priority':
        titleName = 'highlight-priority';
        break;
      case 'delay':
        titleName = 'highlight-delay';
        break;
      default:
        break;
    }
    return colorActives.find(dataColor => dataColor.titleName == titleName);
  }

  /**
   * getColorToUpdate
   * @param dataColor
   * @returns
   */
  private getColorToUpdate(dataColor: any): any {
    let color = {};
    if (dataColor) {
      color = {
        style: dataColor.color,
        opacity: dataColor.opacity,
        mode: dataColor.object == 'time' ? '2' : '1'
      };
    }
    return color;
  }
  /**
   * getApiUpdateData
   */
  private getApiUpdateData(): void {
    this.scheduleOperationManagerService.getApiUpdate().subscribe(data => {
      this.apiUpdateData = data;
    });
  }
  /**
   * get information change date line
   */
  private getInformationScheduleOperation(): void {
    this.commonTableService.getValueCommonTableByKey(Constant.KEY_TIMETABLE_CHANGE_DATE_LINE_TIMETABLE).subscribe(
      data => {
        this.timeDateLine = data ? JSON.parse(data.value) : Constant.TIME_DATE_LINE_DEFAULT;
        this.getDataCurrentDay();
      },
      error => Helper.handleError(error, this.translateService, this.dialogService)
    );
  }
}

/**
 * class DeviceOperation
 */
export class DeviceOperation {
  /**
   * id
   */
  id: Number;
  /**
   * registrationId
   */
  registrationId: string;
  /**
   * deviceId
   */
  deviceId: string;
  /**
   * network
   */
  network: boolean;
  /**
   * capture url
   */
  captureUrl: string;
  /**
   * true if on emergency
   */
  isOnEmergency: boolean;

  constructor(id?: Number, registrationId?: string, deviceId?: string, network?: boolean) {
    this.id = id;
    this.registrationId = registrationId;
    this.deviceId = deviceId;
    this.network = network;
  }
}

export class ScheduleDaily {
  id: number;
  rowDatas: Array<any>;
  isLessCurrentTime: boolean;

  constructor(id: number, rowDatas: Array<any>) {
    this.id = id;
    this.rowDatas = rowDatas;
  }
}
